//
// !! DO NOT EDIT !!
// This file was generated by 'generateStrings.ts' on Wed Sep 24 2025 12:51:23 GMT+0200 (Central European Summer Time)

import { translatable, literalTranslatable } from "./lib/util/Translatable";

// Util strings - DO NOT REMOVE
export const MISC_EMPTY_STRING = literalTranslatable("", "__misc_empty_string");
// Util end

export const MISC_SWITCH_TO = translatable("misc_switch_to");
export const MISC_FIND_GROUP = translatable("misc_find_group");
export const MISC_FLEET = translatable("misc_fleet");
export const MISC_GROUP = translatable("misc_group");
export const MISC_DRIVER = translatable("misc_driver");
export const MISC_DRIVER_PLURAL = translatable("misc_driver_plural");
export const MISC_TARGET = translatable("misc_target");
export const MISC_UNIT = translatable("misc_unit");
export const MISC_EXPORT_DATA = translatable("misc_export_data");
export const MISC_VIEW_DETAILS = translatable("misc_view_details");
export const MISC_ARCHIVED = translatable("misc_archived");
export const MISC_READ = translatable("misc_read");
export const MISC_EXIT = translatable("misc_exit");
export const MISC_LEARN_MORE = translatable("misc_learn_more");
export const MISC_YES = translatable("misc_yes");
export const MISC_NO = translatable("misc_no");
export const MISC_TIME = translatable("misc_time");
export const MISC_TIME_PERIOD = translatable("misc_time_period");
export const MISC_NEVER = translatable("misc_never");
export const MISC_RESTRICTED = translatable("misc_restricted");
export const MISC_NEXT = translatable("misc_next");
export const MISC_UNKNOWN = translatable("misc_unknown");
export const MISC_INCOMPLETE = translatable("misc_incomplete");
export const MISC_DISTANCE = translatable("misc_distance");
export const MISC_MILEAGE = translatable("misc_mileage");
export const MISC_PER = translatable("misc_per");
export const MISC_FOR = translatable("misc_for");
export const MISC_HOUR = translatable("misc_hour");
export const MISC_HOUR_PLURAL = translatable("misc_hour_plural");
export const MISC_MINUTE = translatable("misc_minute");
export const MISC_MINUTE_PLURAL = translatable("misc_minute_plural");
export const MISC_PERSONAL = translatable("misc_personal");
export const MISC_BUSINESS = translatable("misc_business");
export const MISC_TOTAL = translatable("misc_total");
export const MISC_PHONE_NUMBER = translatable("misc_phone_number");
export const MISC_WORKING_HOURS = translatable("misc_working_hours");
export const MISC_EMAIL = translatable("misc_email");
export const MISC_NAME = translatable("misc_name");
export const MISC_EDIT = translatable("misc_edit");
export const MISC_CANCEL = translatable("misc_cancel");
export const MISC_NA = translatable("misc_na");
export const MISC_NONE = translatable("misc_none");
export const MISC_FROM_TO = translatable("misc_from_to");
export const MISC_TOTAL_DISTANCE = translatable("misc_total_distance");
export const MISC_TYPE = translatable("misc_type");
export const MISC_SEE_ALL = translatable("misc_see_all");
export const MISC_NO_DATA = translatable("misc_no_data");
export const MISC_NO_DATA_RECORDED = translatable("misc_no_data_recorded");
export const MISC_LOW_MILEAGE = translatable("misc_low_mileage");
export const MISC_CONTACT_US = translatable("misc_contact_us");
export const MISC_CONTACT_SUPPORT = translatable("misc_contact_support");
export const MISC_NO_RESULTS = translatable("misc_no_results");
export const MISC_PLEASE_WAIT = translatable("misc_please_wait");
export const MISC_LOADING = translatable("misc_loading");
export const MISC_SKIP = translatable("misc_skip");
export const MISC_NOTHING_FOUND = translatable("misc_nothing_found");
export const MISC_SUCCESS = translatable("misc_success");
export const MISC_ERROR = translatable("misc_error");
export const MISC_ERROR_TRY_AGAIN = translatable("misc_error_try_again");
export const MISC_ERROR_APOLOGIES = translatable("misc_error_apologies");
export const MISC_NOT_ENOUGH_DATA = translatable("misc_not_enough_data");
export const MISC_NOT_ENOUGH_MILEAGE = translatable("misc_not_enough_mileage");
export const MISC_ACCEPT = translatable("misc_accept");
export const MISC_FLEET_OR_GROUP = translatable("misc_fleet_or_group");
export const MISC_GREAT_EXCLAMATION = translatable("misc_great_exclamation");
export const MISC_TRY_AGAIN = translatable("misc_try_again");
export const MISC_DELETE = translatable("misc_delete");
export const MISC_GO_BACK = translatable("misc_go_back");
export const MISC_CONTINUE = translatable("misc_continue");
export const MISC_DONE = translatable("misc_done");
export const MISC_UPLOAD_NEW = translatable("misc_upload_new");
export const MISC_AUTHENTICATION = translatable("misc_authentication");
export const MISC_ROW = translatable("misc_row");
export const MISC_DEMO = translatable("misc_demo");
export const MISC_CONFIRM = translatable("misc_confirm");
export const MISC_RETURN_TO = translatable("misc_return_to");
export const MISC_OTHER = translatable("misc_other");
export const MISC_RED = translatable("misc_red");
export const MISC_AMBER = translatable("misc_amber");
export const MISC_GREEN = translatable("misc_green");
export const MISC_SUBMIT = translatable("misc_submit");
export const MISC_CLOSE = translatable("misc_close");
export const MISC_INVALID = translatable("misc_invalid");
export const MISC_MORE = translatable("misc_more");
export const MISC_ALL = translatable("misc_all");
export const MISC_TRIP = translatable("misc_trip");
export const MISC_TRIP_PLURAL = translatable("misc_trip_plural");
export const MISC_SCROLL_TO_TOP = translatable("misc_scroll_to_top");
export const MISC_CLICK_HERE = translatable("misc_click_here");
export const MISC_OPENING_FAQ = translatable("misc_opening_faq");
export const MISC_SAVE = translatable("misc_save");
export const MISC_RESET = translatable("misc_reset");
export const MISC_SELECT_ALL = translatable("misc_select_all");
export const MISC_CLEAR = translatable("misc_clear");
export const MISC_SCORE = translatable("misc_score");
export const MISC_SELECTED = translatable("misc_selected");
export const MISC_GOOD_NEWS = translatable("misc_good_news");
export const MISC_HIDDEN = translatable("misc_hidden");
export const MISC_COPIED_TO_CLIPBOARD = translatable(
	"misc_copied_to_clipboard",
);
export const MISC_VIEW_MORE = translatable("misc_view_more");
export const FIELD_SELECT_ADD_TAGS = translatable("field_select_add_tags");
export const AUTH_ACTION_VERIFY_MANAGER_EMAIL_TITLE = translatable(
	"auth_action_verify_manager_email_title",
);
export const AUTH_ACTION_VERIFY_MANAGER_EMAIL_SUCCESS_TITLE = translatable(
	"auth_action_verify_manager_email_success_title",
);
export const AUTH_ACTION_VERIFY_MANAGER_EMAIL_SUCCESS_COPY = translatable(
	"auth_action_verify_manager_email_success_copy",
);
export const AUTH_ACTION_EXPIRE_COPY = translatable("auth_action_expire_copy");
export const AUTH_ACTION_GENERIC_FAIL_TITLE = translatable(
	"auth_action_generic_fail_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_TITLE = translatable(
	"auth_action_manager_sign_up_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_DESCRIPTION = translatable(
	"auth_action_manager_sign_up_description",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_DETAILS_TITLE = translatable(
	"auth_action_manager_sign_up_details_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_PASSWORD_TITLE = translatable(
	"auth_action_manager_sign_up_password_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_INVALID_CODE_TITLE = translatable(
	"auth_action_manager_sign_up_invalid_code_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_INVALID_CODE_COPY = translatable(
	"auth_action_manager_sign_up_invalid_code_copy",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_INVALID_CODE_SIGN_IN = translatable(
	"auth_action_manager_sign_up_invalid_code_sign_in",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_EXPIRED_CODE_TITLE = translatable(
	"auth_action_manager_sign_up_expired_code_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_EXPIRED_CODE_COPY = translatable(
	"auth_action_manager_sign_up_expired_code_copy",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_EXPIRED_CODE_SUBMIT = translatable(
	"auth_action_manager_sign_up_expired_code_submit",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_SUCCESS_TITLE = translatable(
	"auth_action_manager_sign_up_success_title",
);
export const AUTH_ACTION_MANAGER_SIGN_UP_SUCCESS_COPY = translatable(
	"auth_action_manager_sign_up_success_copy",
);
export const GROUP_SELECTOR_CURRENTLY_VIEWING = translatable(
	"group_selector_currently_viewing",
);
export const GROUP_SELECTOR_CONFIRM = translatable("group_selector_confirm");
export const FORM_ERROR_COMMA_SEPARATED_EMAILS = translatable(
	"form_error_comma_separated_emails",
);
export const FORM_ERROR_LENGTH = translatable("form_error_length");
export const FORM_ERROR_MIN = translatable("form_error_min");
export const FORM_ERROR_MAX = translatable("form_error_max");
export const FORM_ERROR_NOT_CONTAIN = translatable("form_error_not_contain");
export const FORM_ERROR_LOWERCASE = translatable("form_error_lowercase");
export const FORM_ERROR_MATCH = translatable("form_error_match");
export const FORM_ERROR_PHONE_NUMBER = translatable("form_error_phone_number");
export const FORM_ERROR_PHONE_NUMBER_MISSING_COUNTRY_CODE = translatable(
	"form_error_phone_number_missing_country_code",
);
export const FORM_ERROR_EMAIL = translatable("form_error_email");
export const FORM_ERROR_URL = translatable("form_error_url");
export const FORM_ERROR_REQUIRED = translatable("form_error_required");
export const FORM_ERROR_UNIQUE_VALUES = translatable(
	"form_error_unique_values",
);
export const FORM_ERROR_PASSWORD_SHORT = translatable(
	"form_error_password_short",
);
export const FORM_ERROR_PASSWORD_LONG = translatable(
	"form_error_password_long",
);
export const FORM_ERROR_PASSWORD_NUMBERLESS = translatable(
	"form_error_password_numberless",
);
export const FORM_ERROR_PASSWORD_NO_LOWERCASE = translatable(
	"form_error_password_no_lowercase",
);
export const FORM_ERROR_PASSWORD_NO_UPPERCASE = translatable(
	"form_error_password_no_uppercase",
);
export const FORM_ERROR_PASSWORD_INVALID = translatable(
	"form_error_password_invalid",
);
export const SPLASH_BACK_TO_PREVIOUS = translatable("splash_back_to_previous");
export const SPLASH_PAGE_UNAVAILABLE_TITLE = translatable(
	"splash_page_unavailable_title",
);
export const SPLASH_PAGE_UNAVAILABLE_DESCRIPTION = translatable(
	"splash_page_unavailable_description",
);
export const SPLASH_BACK_TO_LOGIN = translatable("splash_back_to_login");
export const SPLASH_CONTACT_US = translatable("splash_contact_us");
export const PROFILE_DETAILS_HEADING = translatable("profile_details_heading");
export const PROFILE_DETAILS_MULTI_FACTOR_HEADING = translatable(
	"profile_details_multi_factor_heading",
);
export const PROFILE_DETAILS_SUBMIT = translatable("profile_details_submit");
export const PROFILE_DETAILS_JOB_TITLE = translatable(
	"profile_details_job_title",
);
export const PROFILE_DETAILS_PRIMARY_WORK_LOCATION = translatable(
	"profile_details_primary_work_location",
);
export const PROFILE_DETAILS_MEASUREMENT_SYSTEM = translatable(
	"profile_details_measurement_system",
);
export const PROFILE_PASSWORD_CURRENT_PASSWORD = translatable(
	"profile_password_current_password",
);
export const PROFILE_PASSWORD_NEW_PASSWORD = translatable(
	"profile_password_new_password",
);
export const PROFILE_PASSWORD_SUBMIT = translatable("profile_password_submit");
export const PROFILE_DETAILS_JOB_TITLE_PLACEHOLDER = translatable(
	"profile_details_job_title_placeholder",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_HEALTH_SAFETY = translatable(
	"profile_details_job_title_option_health_safety",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_RIS = translatable(
	"profile_details_job_title_option_ris",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_LINE_MANAGER = translatable(
	"profile_details_job_title_option_line_manager",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_FLEET_MANAGER = translatable(
	"profile_details_job_title_option_fleet_manager",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_HUMAN_RESOURCES = translatable(
	"profile_details_job_title_option_human_resources",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_COMMERCIAL = translatable(
	"profile_details_job_title_option_commercial",
);
export const PROFILE_DETAILS_JOB_TITLE_OPTION_FINANCE = translatable(
	"profile_details_job_title_option_finance",
);
export const LOGIN_TITLE = translatable("login_title");
export const LOGIN_MANAGER_DASHBOARD = translatable("login_manager_dashboard");
export const LOGIN_SUBMIT_OVERLAY = translatable("login_submit_overlay");
export const LOGIN_SUBMIT = translatable("login_submit");
export const LOGIN_BUSINESS_EMAIL_ADDRESS = translatable(
	"login_business_email_address",
);
export const LOGIN_NO_ACCOUNT = translatable("login_no_account");
export const LOGIN_DRIVER_LINK = translatable("login_driver_link");
export const LOGIN_NO_PERMISSION_ERROR = translatable(
	"login_no_permission_error",
);
export const FORGOT_PASSWORD_SUBMIT_OVERLAY = translatable(
	"forgot_password_submit_overlay",
);
export const FORGOT_PASSWORD_SENT_TITLE = translatable(
	"forgot_password_sent_title",
);
export const FORGOT_PASSWORD_TITLE = translatable("forgot_password_title");
export const FORGOT_PASSWORD_ERROR = translatable("forgot_password_error");
export const FORGOT_PASSWORD_RESEND = translatable("forgot_password_resend");
export const FORGOT_PASSWORD_DESCRIPTION = translatable(
	"forgot_password_description",
);
export const FORGOT_PASSWORD_SEND = translatable("forgot_password_send");
export const CONTROLS_UPLOAD_TITLE = translatable("controls_upload_title");
export const CONTROLS_UPLOAD_UPLOADING = translatable(
	"controls_upload_uploading",
);
export const CONTROLS_UPLOAD_UPLOADED = translatable(
	"controls_upload_uploaded",
);
export const CONTROLS_UPLOAD_RETRY = translatable("controls_upload_retry");
export const CONTROLS_DRAG_DROP_DROP_FILE = translatable(
	"controls_drag_drop_drop_file",
);
export const CONTROLS_SELECT_PLACEHOLDER = translatable(
	"controls_select_placeholder",
);
export const CONTROLS_SELECT_PLACEHOLDER_LOADING = translatable(
	"controls_select_placeholder_loading",
);
export const CONTROLS_MAP_PRESS_TO_ZOOM = translatable(
	"controls_map_press_to_zoom",
);
export const CONTROLS_TIME_SELECT_LAST_4_WEEKS = translatable(
	"controls_time_select_last_4_weeks",
);
export const CONTROLS_TIME_SELECT_LAST_2_MONTHS = translatable(
	"controls_time_select_last_2_months",
);
export const CONTROLS_TIME_SELECT_LAST_3_MONTHS = translatable(
	"controls_time_select_last_3_months",
);
export const CONTROLS_TIME_SELECT_LAST_6_MONTHS = translatable(
	"controls_time_select_last_6_months",
);
export const CONTROLS_TIME_SELECT_LAST_12_MONTHS = translatable(
	"controls_time_select_last_12_months",
);
export const CONTROLS_SEARCH_ADJUST = translatable("controls_search_adjust");
export const UNIT_MILES = translatable("unit_miles");
export const UNIT_KILOMETERS = translatable("unit_kilometers");
export const UNIT_MILES_SHORT = translatable("unit_miles_short");
export const UNIT_KILOMETERS_SHORT = translatable("unit_kilometers_short");
export const UNIT_62_MILES_SHORT = translatable("unit_62_miles_short");
export const UNIT_100_KILOMETERS_SHORT = translatable(
	"unit_100_kilometers_short",
);
export const DRIVER_PROFILE_PILLAR_ERROR_TITLE = translatable(
	"driver_profile_pillar_error_title",
);
export const DRIVER_PROFILE_PILLAR_ERROR_CONTENT = translatable(
	"driver_profile_pillar_error_content",
);
export const DRIVER_PROFILE_CONFIRM_GROUP_CHANGE = translatable(
	"driver_profile_confirm_group_change",
);
export const DRIVER_PROFILE_CONFIRM_GROUP_WARNING_HEADLINE = translatable(
	"driver_profile_confirm_group_warning_headline",
);
export const DRIVER_PROFILE_CONFIRM_GROUP_WARNING_COPY = translatable(
	"driver_profile_confirm_group_warning_copy",
);
export const DRIVER_PROFILE_CREATE_NOTE = translatable(
	"driver_profile_create_note",
);
export const DRIVER_PROFILE_BACK_BUTTON = translatable(
	"driver_profile_back_button",
);
export const DRIVERS_ARCHIVE_CONFIRM_INFO = translatable(
	"drivers_archive_confirm_info",
);
export const DRIVERS_ARCHIVE_CONFIRM_UNARCHIVE_COPY = translatable(
	"drivers_archive_confirm_unarchive_copy",
);
export const DRIVERS_ARCHIVE_CONFIRM_ARCHIVE_COPY = translatable(
	"drivers_archive_confirm_archive_copy",
);
export const DRIVERS_ARCHIVE_CONFIRM_ARCHIVE = translatable(
	"drivers_archive_confirm_archive",
);
export const DRIVERS_ARCHIVE_CONFIRM_UNARCHIVE = translatable(
	"drivers_archive_confirm_unarchive",
);
export const DRIVERS_ARCHIVE_SUCCESS_ARCHIVE = translatable(
	"drivers_archive_success_archive",
);
export const DRIVERS_ARCHIVE_SUCCESS_UNARCHIVE = translatable(
	"drivers_archive_success_unarchive",
);
export const DRIVERS_LTA_CONFIRM_INFO = translatable(
	"drivers_lta_confirm_info",
);
export const DRIVERS_LTA_CONFIRM_UNARCHIVE_COPY = translatable(
	"drivers_lta_confirm_unarchive_copy",
);
export const DRIVERS_LTA_CONFIRM_ARCHIVE_COPY = translatable(
	"drivers_lta_confirm_archive_copy",
);
export const DRIVERS_LTA_CONFIRM_ARCHIVE = translatable(
	"drivers_lta_confirm_archive",
);
export const DRIVERS_LTA_CONFIRM_UNARCHIVE = translatable(
	"drivers_lta_confirm_unarchive",
);
export const DRIVERS_LTA_SUCCESS_ARCHIVE = translatable(
	"drivers_lta_success_archive",
);
export const DRIVERS_LTA_SUCCESS_UNARCHIVE = translatable(
	"drivers_lta_success_unarchive",
);
export const DRIVERS_INVITE_CANCEL_COPY = translatable(
	"drivers_invite_cancel_copy",
);
export const DRIVERS_INVITE_CANCEL_INFO = translatable(
	"drivers_invite_cancel_info",
);
export const DRIVERS_INVITE_CANCEL_SUCCESS = translatable(
	"drivers_invite_cancel_success",
);
export const DRIVERS_INVITE_SSO_SINGLE = translatable(
	"drivers_invite_sso_single",
);
export const DRIVERS_INVITE_SSO_MULTIPLE = translatable(
	"drivers_invite_sso_multiple",
);
export const DRIVERS_INVITE_DUPLICATE_EMAIL_SINGULAR = translatable(
	"drivers_invite_duplicate_email_singular",
);
export const DRIVERS_INVITE_DUPLICATE_EMAIL_PLURAL = translatable(
	"drivers_invite_duplicate_email_plural",
);
export const DRIVERS_DRIVER_DETAILS_TOOLTIP_COPY = translatable(
	"drivers_driver_details_tooltip_copy",
);
export const DRIVERS_TOP_ALERTS_TOOLTIP_TITLE = translatable(
	"drivers_top_alerts_tooltip_title",
);
export const DRIVERS_TOP_ALERTS_TOOLTIP_COPY = translatable(
	"drivers_top_alerts_tooltip_copy",
);
export const GROUP_TOP_ALERTS_TOOLTIP_COPY = translatable(
	"group_top_alerts_tooltip_copy",
);
export const DRIVERS_SPEEDING_ROAD_TYPE_TOOLTIP_HEADING = translatable(
	"drivers_speeding_road_type_tooltip_heading",
);
export const DRIVERS_SPEEDING_ROAD_TYPE_TOOLTIP_COPY = translatable(
	"drivers_speeding_road_type_tooltip_copy",
);
export const DRIVERS_LOADING = translatable("drivers_loading");
export const DRIVERS_DISTANCE_OVER_TIME_RANGE = translatable(
	"drivers_distance_over_time_range",
);
export const DRIVERS_DISTANCE_OVER_TIME = translatable(
	"drivers_distance_over_time",
);
export const DRIVERS_EMAIL_DRIVER = translatable("drivers_email_driver");
export const DRIVERS_EMAIL_DRIVER_PLURAL = translatable(
	"drivers_email_driver_plural",
);
export const DRIVERS_NO_GROUP = translatable("drivers_no_group");
export const DRIVERS_SEE_ALL_DRIVERS = translatable("drivers_see_all_drivers");
export const DRIVERS_DRIVERS = translatable("drivers_drivers");
export const DRIVERS_NO_TRIPS = translatable("drivers_no_trips");
export const DRIVERS_NO_DRIVERS = translatable("drivers_no_drivers");
export const DRIVERS_NO_DRIVERS_DESCRIPTION = translatable(
	"drivers_no_drivers_description",
);
export const DRIVERS_ACTION_UNARCHIVE = translatable(
	"drivers_action_unarchive",
);
export const DRIVERS_ACTION_ARCHIVE = translatable("drivers_action_archive");
export const DRIVERS_ACTION_MARK_LTA = translatable("drivers_action_mark_lta");
export const DRIVERS_ACTION_UNMARK_LTA = translatable(
	"drivers_action_unmark_lta",
);
export const DRIVERS_ACTION_RESET_PASSWORD = translatable(
	"drivers_action_reset_password",
);
export const DRIVERS_ACTION_RESET_PASSWORD_SUCCESS = translatable(
	"drivers_action_reset_password_success",
);
export const DRIVERS_ACTION_RESET_PASSWORD_CONFIRM = translatable(
	"drivers_action_reset_password_confirm",
);
export const DRIVERS_ACTION_RESET_PASSWORD_NEW = translatable(
	"drivers_action_reset_password_new",
);
export const DRIVERS_ACTION_RESET_PASSWORD_GENERATE = translatable(
	"drivers_action_reset_password_generate",
);
export const DRIVERS_ACTION_RESET_PASSWORD_REQUIRE_USER_CHANGE = translatable(
	"drivers_action_reset_password_require_user_change",
);
export const DRIVERS_ASSIGN_TO_GROUP = translatable("drivers_assign_to_group");
export const DRIVERS_DRIVERS_NAME = translatable("drivers_drivers_name");
export const DRIVERS_DRIVERS_POSSESSIVE = translatable(
	"drivers_drivers_possessive",
);
export const DRIVERS_LAST_BUSINESS_TRIP = translatable(
	"drivers_last_business_trip",
);
export const DRIVERS_ARCHIVED_ON = translatable("drivers_archived_on");
export const DRIVERS_LAST_EMAIL_SENT = translatable("drivers_last_email_sent");
export const DRIVERS_STATUS = translatable("drivers_status");
export const DRIVERS_SEARCH_FILTER_PLACEHOLDER = translatable(
	"drivers_search_filter_placeholder",
);
export const DRIVERS_SEARCH_FILTER_BY_GROUP = translatable(
	"drivers_search_filter_by_group",
);
export const DRIVERS_SEARCH_FILTER_NUMBER = translatable(
	"drivers_search_filter_number",
);
export const DRIVERS_SEARCH_FILTER_CLEAR = translatable(
	"drivers_search_filter_clear",
);
export const DRIVERS_SEARCH_FILTER_WITHOUT_SUB_GROUPS = translatable(
	"drivers_search_filter_without_sub_groups",
);
export const DRIVERS_SEARCH_DRIVERS = translatable("drivers_search_drivers");
export const DRIVERS_PROFILE_BACK = translatable("drivers_profile_back");
export const DRIVERS_PROFILE_ARCHIVED_ON = translatable(
	"drivers_profile_archived_on",
);
export const DRIVERS_PROFILE_GROUP = translatable("drivers_profile_group");
export const DRIVERS_STATUS_ARCHIVED_TOOLTIP = translatable(
	"drivers_status_archived_tooltip",
);
export const DRIVERS_STATUS_LTA_TOOLTIP = translatable(
	"drivers_status_lta_tooltip",
);
export const DRIVERS_STATUS_ARCHIVED_NONE = translatable(
	"drivers_status_archived_none",
);
export const DRIVERS_STATUS_LTA_NONE = translatable("drivers_status_lta_none");
export const DRIVERS_STATUS_LTA_NAME = translatable("drivers_status_lta_name");
export const DRIVERS_STATUS_ALL_NAME = translatable("drivers_status_all_name");
export const DRIVERS_STATUS_ALL_TOOLTIP = translatable(
	"drivers_status_all_tooltip",
);
export const DRIVERS_STATUS_INVITED_NAME = translatable(
	"drivers_status_invited_name",
);
export const DRIVERS_STATUS_INVITED_NONE = translatable(
	"drivers_status_invited_none",
);
export const DRIVERS_STATUS_INVITED_TOOLTIP = translatable(
	"drivers_status_invited_tooltip",
);
export const DRIVERS_STATUS_LIVE_NAME = translatable(
	"drivers_status_live_name",
);
export const DRIVERS_STATUS_LIVE_NONE = translatable(
	"drivers_status_live_none",
);
export const DRIVERS_STATUS_LIVE_TOOLTIP = translatable(
	"drivers_status_live_tooltip",
);
export const DRIVERS_STATUS_INACTIVE_NAME = translatable(
	"drivers_status_inactive_name",
);
export const DRIVERS_STATUS_INACTIVE_NONE = translatable(
	"drivers_status_inactive_none",
);
export const DRIVERS_STATUS_INACTIVE_TOOLTIP = translatable(
	"drivers_status_inactive_tooltip",
);
export const DRIVERS_SUB_STATUS_UNDELIVERED_NAME = translatable(
	"drivers_sub_status_undelivered_name",
);
export const DRIVERS_SUB_STATUS_UNDELIVERED_LABEL = translatable(
	"drivers_sub_status_undelivered_label",
);
export const DRIVERS_SUB_STATUS_UNDELIVERED_NONE = translatable(
	"drivers_sub_status_undelivered_none",
);
export const DRIVERS_SUB_STATUS_READ_NAME = translatable(
	"drivers_sub_status_read_name",
);
export const DRIVERS_SUB_STATUS_READ_LABEL = translatable(
	"drivers_sub_status_read_label",
);
export const DRIVERS_SUB_STATUS_READ_NONE = translatable(
	"drivers_sub_status_read_none",
);
export const DRIVERS_SUB_STATUS_PENDING_NAME = translatable(
	"drivers_sub_status_pending_name",
);
export const DRIVERS_SUB_STATUS_PENDING_LABEL = translatable(
	"drivers_sub_status_pending_label",
);
export const DRIVERS_SUB_STATUS_PENDING_NONE = translatable(
	"drivers_sub_status_pending_none",
);
export const DRIVERS_SUB_STATUS_UNREAD_LABEL = translatable(
	"drivers_sub_status_unread_label",
);
export const DRIVERS_SUB_STATUS_UNREAD_NONE = translatable(
	"drivers_sub_status_unread_none",
);
export const DRIVERS_SUB_STATUS_UNINSTALLED_LABEL = translatable(
	"drivers_sub_status_uninstalled_label",
);
export const DRIVERS_SUB_STATUS_UNINSTALLED_NONE = translatable(
	"drivers_sub_status_uninstalled_none",
);
export const DRIVERS_SUB_STATUS_LOGGED_OUT_LABEL = translatable(
	"drivers_sub_status_logged_out_label",
);
export const DRIVERS_SUB_STATUS_LOGGED_OUT_NONE = translatable(
	"drivers_sub_status_logged_out_none",
);
export const DRIVERS_SUB_STATUS_PRIVATE_MODE_LABEL = translatable(
	"drivers_sub_status_private_mode_label",
);
export const DRIVERS_SUB_STATUS_PRIVATE_MODE_NONE = translatable(
	"drivers_sub_status_private_mode_none",
);
export const DRIVERS_SUB_STATUS_LOCATION_BLOCKED_LABEL = translatable(
	"drivers_sub_status_location_blocked_label",
);
export const DRIVERS_SUB_STATUS_LOCATION_BLOCKED_NONE = translatable(
	"drivers_sub_status_location_blocked_none",
);
export const DRIVERS_SUB_STATUS_EMAIL_UNVERIFIED_LABEL = translatable(
	"drivers_sub_status_email_unverified_label",
);
export const DRIVERS_SUB_STATUS_EMAIL_UNVERIFIED_NONE = translatable(
	"drivers_sub_status_email_unverified_none",
);
export const DRIVERS_SUB_STATUS_UNKNOWN_LABEL = translatable(
	"drivers_sub_status_unknown_label",
);
export const DRIVERS_SUB_STATUS_UNKNOWN_NONE = translatable(
	"drivers_sub_status_unknown_none",
);
export const DRIVERS_WORKING_PERCENTAGE = translatable(
	"drivers_working_percentage",
);
export const DRIVERS_WORKING_HOURS = translatable("drivers_working_hours");
export const DRIVERS_WORKING_HOURS_DEFAULTS = translatable(
	"drivers_working_hours_defaults",
);
export const DRIVERS_ENVIRONMENT_HEADING = translatable(
	"drivers_environment_heading",
);
export const DRIVERS_ENVIRONMENT_CHART_TOOLTIP = translatable(
	"drivers_environment_chart_tooltip",
);
export const DRIVERS_ENVIRONMENT_LABEL = translatable(
	"drivers_environment_label",
);
export const DRIVERS_ENVIRONMENT_TYPE_EXTRA_URBAN = translatable(
	"drivers_environment_type_extra_urban",
);
export const DRIVERS_ENVIRONMENT_TYPE_URBAN = translatable(
	"drivers_environment_type_urban",
);
export const DRIVERS_ENVIRONMENT_TYPE_MOTORWAY_DUAL_CARRIAGEWAY = translatable(
	"drivers_environment_type_motorway_dual_carriageway",
);
export const DRIVERS_ENVIRONMENT_ROADS = translatable(
	"drivers_environment_roads",
);
export const DRIVERS_BENCHMARK_NAME = translatable("drivers_benchmark_name");
export const DRIVERS_BENCHMARK_FIRST = translatable("drivers_benchmark_first");
export const DRIVERS_DETECTION_AVOIDANCE_PRIVATE_MODE = translatable(
	"drivers_detection_avoidance_private_mode",
);
export const DRIVERS_DETECTION_AVOIDANCE_LOGGED_OUT = translatable(
	"drivers_detection_avoidance_logged_out",
);
export const DRIVERS_DETECTION_AVOIDANCE_LOCATION_BLOCKED = translatable(
	"drivers_detection_avoidance_location_blocked",
);
export const DRIVERS_DETECTION_AVOIDANCE_GLOBAL_LOCATION_BLOCKED = translatable(
	"drivers_detection_avoidance_global_location_blocked",
);
export const DRIVERS_DETECTION_AVOIDANCE_UNINSTALLED = translatable(
	"drivers_detection_avoidance_uninstalled",
);
export const DRIVERS_DETECTION_AVOIDANCE_NO_GPS = translatable(
	"drivers_detection_avoidance_no_gps",
);
export const DRIVERS_DETECTION_AVOIDANCE_STAT_GROUP_DESCRIPTION = translatable(
	"drivers_detection_avoidance_stat_group_description",
);
export const DRIVERS_DETECTION_AVOIDANCE_STAT_DRIVER_DESCRIPTION = translatable(
	"drivers_detection_avoidance_stat_driver_description",
);
export const DRIVERS_DETECTION_AVOIDANCE_HEADING = translatable(
	"drivers_detection_avoidance_heading",
);
export const DRIVERS_DETECTION_AVOIDANCE_SUBHEADING = translatable(
	"drivers_detection_avoidance_subheading",
);
export const DRIVERS_APP_USAGE_HEADING = translatable(
	"drivers_app_usage_heading",
);
export const DRIVERS_APP_USAGE_SIGN_UP_DATE = translatable(
	"drivers_app_usage_sign_up_date",
);
export const DRIVERS_APP_USAGE_LAST_TRIP_LOGGED = translatable(
	"drivers_app_usage_last_trip_logged",
);
export const DRIVERS_APP_USAGE_LAST_INTERACTION_WITH_APP = translatable(
	"drivers_app_usage_last_interaction_with_app",
);
export const DRIVERS_APP_USAGE_NO_INTERACTIONS = translatable(
	"drivers_app_usage_no_interactions",
);
export const DRIVERS_APP_USAGE_ACTIVITY_STATS_HEADING = translatable(
	"drivers_app_usage_activity_stats_heading",
);
export const DRIVERS_APP_USAGE_PERIODIC_REFRESH = translatable(
	"drivers_app_usage_periodic_refresh",
);
export const DRIVERS_APP_USAGE_INTERACTIONS_HEADING = translatable(
	"drivers_app_usage_interactions_heading",
);
export const DRIVERS_APP_USAGE_INTERACTIONS_LAST_7_DAYS = translatable(
	"drivers_app_usage_interactions_last_7_days",
);
export const MISC_AVERAGE = translatable("misc_average");
export const DRIVERS_APP_USAGE_INTERACTIONS_AVERAGE_LAST_7_DAYS = translatable(
	"drivers_app_usage_interactions_average_last_7_days",
);
export const DRIVERS_APP_USAGE_INTERACTIONS_AVERAGE_INTERACTIONS = translatable(
	"drivers_app_usage_interactions_average_interactions",
);
export const DRIVERS_DRIVER_DETAILS_HEADING = translatable(
	"drivers_driver_details_heading",
);
export const DRIVERS_DRIVER_DETAILS_MANAGER_DETAILS = translatable(
	"drivers_driver_details_manager_details",
);
export const DRIVERS_DRIVER_DETAILS_MANAGER_DETAILS_UPDATE = translatable(
	"drivers_driver_details_manager_details_update",
);
export const DRIVERS_VEHICLE_DETAILS_ENGINE_SIZE = translatable(
	"drivers_vehicle_details_engine_size",
);
export const DRIVERS_VEHICLE_DETAILS_MODEL = translatable(
	"drivers_vehicle_details_model",
);
export const DRIVERS_VEHICLE_DETAILS_MAKE = translatable(
	"drivers_vehicle_details_make",
);
export const DRIVERS_VEHICLE_DETAILS_REGISTRATION_NUMBER = translatable(
	"drivers_vehicle_details_registration_number",
);
export const DRIVERS_VEHICLE_DETAILS_MILEAGE_MANAGER_SETTINGS = translatable(
	"drivers_vehicle_details_mileage_manager_settings",
);
export const DRIVERS_VEHICLE_DETAILS_DRIVER_CLAIMS = translatable(
	"drivers_vehicle_details_driver_claims",
);
export const DRIVERS_VEHICLE_DETAILS_NO_VEHICLES = translatable(
	"drivers_vehicle_details_no_vehicles",
);
export const DRIVERS_VEHICLE_DETAILS_HEADING = translatable(
	"drivers_vehicle_details_heading",
);
export const DRIVERS_VEHICLE_DETAILS_TOOLTIP_COPY = translatable(
	"drivers_vehicle_details_tooltip_copy",
);
export const DRIVERS_VEHICLE_DETAILS_LAST_EXPENSE_REPORT = translatable(
	"drivers_vehicle_details_last_expense_report",
);
export const DRIVERS_RISK_EVENTS_HEADING = translatable(
	"drivers_risk_events_heading",
);
export const DRIVERS_RISK_EVENTS_NO_EVENTS = translatable(
	"drivers_risk_events_no_events",
);
export const GROUP_RISK_EVENTS_NO_EVENTS = translatable(
	"group_risk_events_no_events",
);
export const DRIVERS_CHARACTERISTICS_HEADING = translatable(
	"drivers_characteristics_heading",
);
export const DRIVERS_BENCHMARK_WARNING_TITLE = translatable(
	"drivers_benchmark_warning_title",
);
export const DRIVERS_BENCHMARK_WARNING_COPY = translatable(
	"drivers_benchmark_warning_copy",
);
export const DRIVERS_14_DAYS_WARNING_TITLE = translatable(
	"drivers_14_days_warning_title",
);
export const DRIVERS_14_DAYS_WARNING_COPY = translatable(
	"drivers_14_days_warning_copy",
);
export const DRIVERS_NOTES_VIEW = translatable("drivers_notes_view");
export const DRIVERS_NOTES_ADD = translatable("drivers_notes_add");
export const DRIVERS_NOTES_TITLE = translatable("drivers_notes_title");
export const DRIVERS_SPEEDING_BY_ROAD_TYPE_TITLE = translatable(
	"drivers_speeding_by_road_type_title",
);
export const DRIVERS_MOVE_GROUP = translatable("drivers_move_group");
export const INVITE_INVITE_ACTION = translatable("invite_invite_action");
export const INVITE_INVITE_ACTION_PLURAL = translatable(
	"invite_invite_action_plural",
);
export const INVITE_CLOSE_CONFIRM_TITLE = translatable(
	"invite_close_confirm_title",
);
export const INVITE_CLOSE_CONFIRM_COPY = translatable(
	"invite_close_confirm_copy",
);
export const INVITE_EDIT_INVITE = translatable("invite_edit_invite");
export const INVITE_CANCEL_INVITE = translatable("invite_cancel_invite");
export const INVITE_INVITE_DRIVERS = translatable("invite_invite_drivers");
export const INVITE_REMINDER_SENT = translatable("invite_reminder_sent");
export const INVITE_REMINDER_SENT_PLURAL = translatable(
	"invite_reminder_sent_plural",
);
export const INVITE_REMINDER_SEND_AGAIN = translatable(
	"invite_reminder_send_again",
);
export const INVITE_REMINDER_SEND_FIRST = translatable(
	"invite_reminder_send_first",
);
export const INVITE_UPDATE_EMAIL = translatable("invite_update_email");
export const INVITE_UNDELIVERED_TOOLTIP_TITLE = translatable(
	"invite_undelivered_tooltip_title",
);
export const INVITE_UNDELIVERED_TOOLTIP_CONTENT = translatable(
	"invite_undelivered_tooltip_content",
);
export const INVITE_INVITE_SENT_ON = translatable("invite_invite_sent_on");
export const ALL_STATUS = translatable("all_status");
export const ALL_STATUS_PLURAL = translatable("all_status_plural");
export const ALL_STATUS_FILTER = translatable("all_status_filter");
export const ALL_STATUS_FILTER_PLURAL = translatable(
	"all_status_filter_plural",
);
export const LIVE_STATUS = translatable("live_status");
export const LIVE_STATUS_PLURAL = translatable("live_status_plural");
export const LIVE_STATUS_FILTER = translatable("live_status_filter");
export const LIVE_STATUS_FILTER_PLURAL = translatable(
	"live_status_filter_plural",
);
export const INVITE_YET_TO_SIGNUP = translatable("invite_yet_to_signup");
export const INVITE_YET_TO_SIGNUP_PLURAL = translatable(
	"invite_yet_to_signup_plural",
);
export const INVITE_YET_TO_SIGNUP_FILTER = translatable(
	"invite_yet_to_signup_filter",
);
export const INVITE_YET_TO_SIGNUP_FILTER_PLURAL = translatable(
	"invite_yet_to_signup_filter_plural",
);
export const READ_STATUS = translatable("read_status");
export const READ_STATUS_PLURAL = translatable("read_status_plural");
export const READ_STATUS_FILTER = translatable("read_status_filter");
export const READ_STATUS_FILTER_PLURAL = translatable(
	"read_status_filter_plural",
);
export const UNREAD_STATUS = translatable("unread_status");
export const UNREAD_STATUS_PLURAL = translatable("unread_status_plural");
export const UNREAD_STATUS_FILTER = translatable("unread_status_filter");
export const UNREAD_STATUS_FILTER_PLURAL = translatable(
	"unread_status_filter_plural",
);
export const UNDELIVERED_STATUS = translatable("undelivered_status");
export const UNDELIVERED_STATUS_PLURAL = translatable(
	"undelivered_status_plural",
);
export const UNDELIVERED_STATUS_FILTER = translatable(
	"undelivered_status_filter",
);
export const UNDELIVERED_STATUS_FILTER_PLURAL = translatable(
	"undelivered_status_filter_plural",
);
export const PENDING_STATUS = translatable("pending_status");
export const PENDING_STATUS_PLURAL = translatable("pending_status_plural");
export const PENDING_STATUS_FILTER = translatable("pending_status_filter");
export const PENDING_STATUS_FILTER_PLURAL = translatable(
	"pending_status_filter_plural",
);
export const INVITE_SEND_REMINDER = translatable("invite_send_reminder");
export const INACTIVE_STATUS_PLURAL = translatable("inactive_status_plural");
export const INACTIVE_STATUS = translatable("inactive_status");
export const INACTIVE_STATUS_FILTER_PLURAL = translatable(
	"inactive_status_filter_plural",
);
export const INACTIVE_STATUS_FILTER = translatable("inactive_status_filter");
export const UNINSTALLED_STATUS_PLURAL = translatable(
	"uninstalled_status_plural",
);
export const UNINSTALLED_STATUS = translatable("uninstalled_status");
export const UNINSTALLED_STATUS_FILTER_PLURAL = translatable(
	"uninstalled_status_filter_plural",
);
export const UNINSTALLED_STATUS_FILTER = translatable(
	"uninstalled_status_filter",
);
export const LOGGED_OUT_STATUS_PLURAL = translatable(
	"logged_out_status_plural",
);
export const LOGGED_OUT_STATUS = translatable("logged_out_status");
export const LOGGED_OUT_STATUS_FILTER_PLURAL = translatable(
	"logged_out_status_filter_plural",
);
export const LOGGED_OUT_STATUS_FILTER = translatable(
	"logged_out_status_filter",
);
export const PRIVATE_MODE_STATUS_PLURAL = translatable(
	"private_mode_status_plural",
);
export const PRIVATE_MODE_STATUS = translatable("private_mode_status");
export const PRIVATE_MODE_STATUS_FILTER_PLURAL = translatable(
	"private_mode_status_filter_plural",
);
export const PRIVATE_MODE_STATUS_FILTER = translatable(
	"private_mode_status_filter",
);
export const LOCATION_BLOCKED_STATUS_PLURAL = translatable(
	"location_blocked_status_plural",
);
export const LOCATION_BLOCKED_STATUS = translatable("location_blocked_status");
export const LOCATION_BLOCKED_STATUS_FILTER_PLURAL = translatable(
	"location_blocked_status_filter_plural",
);
export const LOCATION_BLOCKED_STATUS_FILTER = translatable(
	"location_blocked_status_filter",
);
export const EMAIL_UNVERIFIED_STATUS_PLURAL = translatable(
	"email_unverified_status_plural",
);
export const EMAIL_UNVERIFIED_STATUS = translatable("email_unverified_status");
export const EMAIL_UNVERIFIED_STATUS_FILTER_PLURAL = translatable(
	"email_unverified_status_filter_plural",
);
export const EMAIL_UNVERIFIED_STATUS_FILTER = translatable(
	"email_unverified_status_filter",
);
export const INACTIVE_GET_IN_TOUCH = translatable("inactive_get_in_touch");
export const INACTIVE_SEND_MESSAGE = translatable("inactive_send_message");
export const INACTIVE_SEND_MESSAGE_AGAIN = translatable(
	"inactive_send_message_again",
);
export const INACTIVE_MESSAGE_SENT_ON = translatable(
	"inactive_message_sent_on",
);
export const INACTIVE_MESSAGE_SENT = translatable("inactive_message_sent");
export const INACTIVE_MESSAGE_SENT_PLURAL = translatable(
	"inactive_message_sent_plural",
);
export const INVITE_INVITE_TITLE = translatable("invite_invite_title");
export const INVITE_INVITE_INSTRUCTIONS = translatable(
	"invite_invite_instructions",
);
export const INVITE_UPLOAD_ACTION = translatable("invite_upload_action");
export const INVITE_MANUAL_ACTION = translatable("invite_manual_action");
export const INVITE_LOCALE_TITLE = translatable("invite_locale_title");
export const INVITE_LOCALE_EN = translatable("invite_locale_en");
export const INVITE_LOCALE_FR = translatable("invite_locale_fr");
export const INVITE_LOCALE_ES = translatable("invite_locale_es");
export const INVITE_LOCALE_RU = translatable("invite_locale_ru");
export const INVITE_LOCALE_PT = translatable("invite_locale_pt");
export const INVITE_LOCALE_IT = translatable("invite_locale_it");
export const INVITE_LOCALE_TR = translatable("invite_locale_tr");
export const INVITE_LOCALE_HE = translatable("invite_locale_he");
export const INVITE_LOCALE_NL = translatable("invite_locale_nl");
export const INVITE_LOCALE_DE = translatable("invite_locale_de");
export const INVITE_LOCALE_RO = translatable("invite_locale_ro");
export const INVITE_LOCALE_VI = translatable("invite_locale_vi");
export const INVITE_LOCALE_ZH = translatable("invite_locale_zh");
export const INVITE_LOCALE_KM = translatable("invite_locale_km");
export const INVITE_LOCALE_PL = translatable("invite_locale_pl");
export const INVITE_LOCALE_EL = translatable("invite_locale_el");
export const INVITE_LOCALE_AR = translatable("invite_locale_ar");
export const INVITE_LOCALE_ID = translatable("invite_locale_id");
export const INVITE_LOCALE_DA = translatable("invite_locale_da");
export const INVITE_LOCALE_HU = translatable("invite_locale_hu");
export const INVITE_LOCALE_FIL = translatable("invite_locale_fil");
export const INVITE_LOCALE_TH = translatable("invite_locale_th");
export const INVITE_LOCALE_JA = translatable("invite_locale_ja");
export const INVITE_LOCALE_KO = translatable("invite_locale_ko");
export const INVITE_LOCALE_BG = translatable("invite_locale_bg");
export const INVITE_LOCALE_CS = translatable("invite_locale_cs");
export const INVITE_LOCALE_SK = translatable("invite_locale_sk");
export const INVITE_MANUAL_TITLE = translatable("invite_manual_title");
export const INVITE_MANUAL_INSTRUCTION = translatable(
	"invite_manual_instruction",
);
export const INVITE_MANUAL_LIMIT_TITLE = translatable(
	"invite_manual_limit_title",
);
export const INVITE_MANUAL_LIMIT_COPY = translatable(
	"invite_manual_limit_copy",
);
export const INVITE_MANUAL_SWITCH_TO_UPLOAD = translatable(
	"invite_manual_switch_to_upload",
);
export const INVITE_NAME_TITLE = translatable("invite_name_title");
export const INVITE_NAME_COPY = translatable("invite_name_copy");
export const INVITE_NAME_AUTO_FILL = translatable("invite_name_auto_fill");
export const INVITE_NAME_NO_AUTO_FILL = translatable(
	"invite_name_no_auto_fill",
);
export const INVITE_NAME_FIRST_NAME = translatable("invite_name_first_name");
export const INVITE_NAME_LAST_NAME = translatable("invite_name_last_name");
export const INVITE_GROUPS_MULTI_ASSIGN = translatable(
	"invite_groups_multi_assign",
);
export const INVITE_GROUPS_ASSIGN_TO_ALL = translatable(
	"invite_groups_assign_to_all",
);
export const INVITE_GROUPS_TITLE = translatable("invite_groups_title");
export const INVITE_NO_GROUPS_TITLE = translatable("invite_no_groups_title");
export const INVITE_GROUPS_UNASSIGNED = translatable(
	"invite_groups_unassigned",
);
export const INVITE_GROUPS_UNASSIGNED_PLURAL = translatable(
	"invite_groups_unassigned_plural",
);
export const INVITE_UPLOAD_TITLE = translatable("invite_upload_title");
export const INVITE_UPLOAD_SWITCH_MANUAL = translatable(
	"invite_upload_switch_manual",
);
export const INVITE_UPLOAD_LIMIT_TITLE = translatable(
	"invite_upload_limit_title",
);
export const INVITE_UPLOAD_LIMIT_COPY = translatable(
	"invite_upload_limit_copy",
);
export const INVITE_UPLOAD_NO_DRIVERS_TITLE = translatable(
	"invite_upload_no_drivers_title",
);
export const INVITE_UPLOAD_NO_EMAILS = translatable("invite_upload_no_emails");
export const INVITE_UPLOAD_AREA_COPY = translatable("invite_upload_area_copy");
export const INVITE_UPLOAD_AREA_COPY_MOBILE = translatable(
	"invite_upload_area_copy_mobile",
);
export const INVITE_UPLOAD_AREA_ERROR = translatable(
	"invite_upload_area_error",
);
export const INVITE_UPLOAD_DESCRIPTION = translatable(
	"invite_upload_description",
);
export const INVITE_ALREADY_SIGNED_UP = translatable(
	"invite_already_signed_up",
);
export const INVITE_ALREADY_SIGNED_UP_COPY = translatable(
	"invite_already_signed_up_copy",
);
export const INVITE_ALREADY_SIGNED_UP_PLURAL = translatable(
	"invite_already_signed_up_plural",
);
export const INVITE_ALREADY_SIGNED_UP_COPY_PLURAL = translatable(
	"invite_already_signed_up_copy_plural",
);
export const MANAGER_ALREADY_SIGNED_UP = translatable(
	"manager_already_signed_up",
);
export const MANAGER_ALREADY_SIGNED_UP_COPY = translatable(
	"manager_already_signed_up_copy",
);
export const MANAGER_ALREADY_SIGNED_UP_PLURAL = translatable(
	"manager_already_signed_up_plural",
);
export const MANAGER_ALREADY_SIGNED_UP_COPY_PLURAL = translatable(
	"manager_already_signed_up_copy_plural",
);
export const INVITE_SUCCESS_TITLE = translatable("invite_success_title");
export const INVITE_SUCCESS_TITLE_PLURAL = translatable(
	"invite_success_title_plural",
);
export const INVITE_REMINDERS_SUCCESS = translatable(
	"invite_reminders_success",
);
export const INVITE_REMINDERS_SUCCESS_PLURAL = translatable(
	"invite_reminders_success_plural",
);
export const INVITE_SUCCESS_INVITE_MORE = translatable(
	"invite_success_invite_more",
);
export const INVITE_SUCCESS_COPY = translatable("invite_success_copy");
export const INVITE_REMINDERS_SEND_AGAIN = translatable(
	"invite_reminders_send_again",
);
export const INVITE_REMINDERS_DO_NOT_SEND_AGAIN = translatable(
	"invite_reminders_do_not_send_again",
);
export const INVITE_REMINDERS_ALREADY_SENT_TITLE = translatable(
	"invite_reminders_already_sent_title",
);
export const INVITE_REMINDERS_ALREADY_SENT_TITLE_PLURAL = translatable(
	"invite_reminders_already_sent_title_plural",
);
export const INVITE_REMINDERS_ALREADY_SENT_COPY = translatable(
	"invite_reminders_already_sent_copy",
);
export const INVITE_REMINDERS_ALREADY_SENT_COPY_PLURAL = translatable(
	"invite_reminders_already_sent_copy_plural",
);
export const INVITE_UPLOAD_ERROR = translatable("invite_upload_error");
export const INVITE_UPLOAD_ERROR_PLURAL = translatable(
	"invite_upload_error_plural",
);
export const INVITE_UPLOAD_ERROR_INSTRUCTIONS = translatable(
	"invite_upload_error_instructions",
);
export const MESSAGE_PERSONAL_SUBJECT_LINE = translatable(
	"message_personal_subject_line",
);
export const MESSAGE_PERSONAL_MESSAGE = translatable(
	"message_personal_message",
);
export const MESSAGE_PREVIEW_TITLE = translatable("message_preview_title");
export const MESSAGE_PREVIEW_NOTE = translatable("message_preview_note");
export const MESSAGE_PREVIEW_LINK = translatable("message_preview_link");
export const MESSAGE_PREVIEW_LINK_MOBILE = translatable(
	"message_preview_link_mobile",
);
export const MESSAGE_LAST_MESSAGE_SENT = translatable(
	"message_last_message_sent",
);
export const REMINDER_TITLE = translatable("reminder_title");
export const REMINDER_TITLE_DEFAULT = translatable("reminder_title_default");
export const REMINDER_TITLE_READ = translatable("reminder_title_read");
export const REMINDER_TITLE_UNREAD = translatable("reminder_title_unread");
export const REMINDER_TITLE_UNDELIVERED = translatable(
	"reminder_title_undelivered",
);
export const REMINDER_TITLE_PENDING = translatable("reminder_title_pending");
export const REMINDER_TITLE_SINGLE = translatable("reminder_title_single");
export const REMINDER_DESCRIPTION = translatable("reminder_description");
export const REMINDER_DESCRIPTION_SINGLE = translatable(
	"reminder_description_single",
);
export const REMINDER_DO_NOT_INCLUDE_LAST_7 = translatable(
	"reminder_do_not_include_last_7",
);
export const INACTIVE_DO_NOT_INCLUDE_LAST_7 = translatable(
	"inactive_do_not_include_last_7",
);
export const REMINDER_SEND_FROM_OWN_ACCOUNT = translatable(
	"reminder_send_from_own_account",
);
export const REMINDER_SEND = translatable("reminder_send");
export const REMINDER_SEND_SINGLE = translatable("reminder_send_single");
export const INACTIVE_TITLE = translatable("inactive_title");
export const INACTIVE_TITLE_DEFAULT = translatable("inactive_title_default");
export const INACTIVE_TITLE_UNINSTALLED = translatable(
	"inactive_title_uninstalled",
);
export const INACTIVE_TITLE_LOGGED_OUT = translatable(
	"inactive_title_logged_out",
);
export const INACTIVE_TITLE_PRIVATE_MODE = translatable(
	"inactive_title_private_mode",
);
export const INACTIVE_TITLE_LOCATION_BLOCKED = translatable(
	"inactive_title_location_blocked",
);
export const INACTIVE_TITLE_EMAIL_UNVERIFIED = translatable(
	"inactive_title_email_unverified",
);
export const INACTIVE_TITLE_SINGLE = translatable("inactive_title_single");
export const INACTIVE_DESCRIPTION = translatable("inactive_description");
export const INACTIVE_DESCRIPTION_SINGLE = translatable(
	"inactive_description_single",
);
export const INACTIVE_DO_NO_INCLUDE_LAST_7 = translatable(
	"inactive_do_no_include_last_7",
);
export const INACTIVE_SEND = translatable("inactive_send");
export const INACTIVE_SEND_SINGLE = translatable("inactive_send_single");
export const NAVIGATION_HOME = translatable("navigation_home");
export const NAVIGATION_SIGN_IN = translatable("navigation_sign_in");
export const NAVIGATION_INSIGHTS = translatable("navigation_insights");
export const NAVIGATION_FILES = translatable("navigation_files");
export const NAVIGATION_DRIVERS = translatable("navigation_drivers");
export const NAVIGATION_COMPARE = translatable("navigation_compare");
export const NAVIGATION_SUPPORT = translatable("navigation_support");
export const NAVIGATION_LANGUAGE = translatable("navigation_language");
export const NAVIGATION_MY_PROFILE = translatable("navigation_my_profile");
export const NAVIGATION_FAQ = translatable("navigation_faq");
export const NAVIGATION_RESET_ONBOARDING = translatable(
	"navigation_reset_onboarding",
);
export const NAVIGATION_PRIVACY_POLICY = translatable(
	"navigation_privacy_policy",
);
export const NAVIGATION_USER_GUIDE = translatable("navigation_user_guide");
export const NAVIGATION_DEMO = translatable("navigation_demo");
export const NAVIGATION_ANONYMOUS_MODE = translatable(
	"navigation_anonymous_mode",
);
export const NAVIGATION_SIGN_OUT = translatable("navigation_sign_out");
export const DASHBOARD_BROWSER_WARNING = translatable(
	"dashboard_browser_warning",
);
export const DASHBOARD_BROWSER_UPGRADE = translatable(
	"dashboard_browser_upgrade",
);
export const OUTDATED_BROWSER_WARNING = translatable(
	"outdated_browser_warning",
);
export const OUTDATED_BROWSER_UPGRADE = translatable(
	"outdated_browser_upgrade",
);
export const OUTDATED_BROWSER_LINK = translatable("outdated_browser_link");
export const OUTDATED_BROWSER_CONTACT = translatable(
	"outdated_browser_contact",
);
export const DASHBOARD_SUMMARY_PILLAR_GROUP_SCOPE = translatable(
	"dashboard_summary_pillar_group_scope",
);
export const DASHBOARD_SUMMARY_PILLAR_DRIVER_SCOPE = translatable(
	"dashboard_summary_pillar_driver_scope",
);
export const DASHBOARD_ALL_PILLARS = translatable("dashboard_all_pillars");
export const DASHBOARD_NO_DRIVERS_TITLE = translatable(
	"dashboard_no_drivers_title",
);
export const DASHBOARD_NO_DRIVERS_COPY = translatable(
	"dashboard_no_drivers_copy",
);
export const DASHBOARD_TRENDS_TOOLTIP_TITLE = translatable(
	"dashboard_trends_tooltip_title",
);
export const DASHBOARD_TRENDS_TOOLTIP_COPY = translatable(
	"dashboard_trends_tooltip_copy",
);
export const DASHBOARD_SUMMARY_SM_TOOLTIP_TITLE = translatable(
	"dashboard_summary_sm_tooltip_title",
);
export const DASHBOARD_SUMMARY_SM_TOOLTIP_COPY = translatable(
	"dashboard_summary_sm_tooltip_copy",
);
export const DASHBOARD_SUMMARY_TOOLTIP_TITLE = translatable(
	"dashboard_summary_tooltip_title",
);
export const DASHBOARD_SUMMARY_TOOLTIP_COPY = translatable(
	"dashboard_summary_tooltip_copy",
);
export const DASHBOARD_TOTAL_ALERT_PLURAL = translatable(
	"dashboard_total_alert_plural",
);
export const DASHBOARD_TOTAL_ALERT = translatable("dashboard_total_alert");
export const DASHBOARD_HOTSPOTS_TITLE = translatable(
	"dashboard_hotspots_title",
);
export const DASHBOARD_HOTSPOTS_POINTS_OF_INTEREST = translatable(
	"dashboard_hotspots_points_of_interest",
);
export const DASHBOARD_HOTSPOTS_TOOLTIP_TITLE = translatable(
	"dashboard_hotspots_tooltip_title",
);
export const DASHBOARD_HOTSPOTS_TOOLTIP_COPY_RISK = translatable(
	"dashboard_hotspots_tooltip_copy_risk",
);
export const DASHBOARD_HOTSPOTS_TOOLTIP_COPY_DISTRACTION = translatable(
	"dashboard_hotspots_tooltip_copy_distraction",
);
export const DASHBOARD_HOTSPOTS_TOOLTIP_COPY_ECO = translatable(
	"dashboard_hotspots_tooltip_copy_eco",
);
export const DASHBOARD_GROUP_DISTRIBUTION = translatable(
	"dashboard_group_distribution",
);
export const DASHBOARD_TOTAL_DISTANCE_TOOLTIP = translatable(
	"dashboard_total_distance_tooltip",
);
export const DASHBOARD_TOTAL_TRIPS_TOOLTIP = translatable(
	"dashboard_total_trips_tooltip",
);
export const DASHBOARD_LIVE_DRIVERS = translatable("dashboard_live_drivers");
export const DASHBOARD_LIVE_DRIVERS_TOOLTIP = translatable(
	"dashboard_live_drivers_tooltip",
);
export const DASHBOARD_TOTAL_TRIPS = translatable("dashboard_total_trips");
export const DASHBOARD_HERO_HEADING = translatable("dashboard_hero_heading");
export const DASHBOARD_ROAD_TYPE_HEADING = translatable(
	"dashboard_road_type_heading",
);
export const DASHBOARD_ROAD_TYPE_URBAN = translatable(
	"dashboard_road_type_urban",
);
export const DASHBOARD_ROAD_TYPE_EXTRA_URBAN = translatable(
	"dashboard_road_type_extra_urban",
);
export const DASHBOARD_ROAD_TYPE_MOTORWAY = translatable(
	"dashboard_road_type_motorway",
);
export const DASHBOARD_ROAD_TYPE_Y_AXIS_LABEL = translatable(
	"dashboard_road_type_y_axis_label",
);
export const DASHBOARD_ROAD_TYPE_LEGEND_TITLE = translatable(
	"dashboard_road_type_legend_title",
);
export const DASHBOARD_ROAD_TYPE_LEGEND_LOW = translatable(
	"dashboard_road_type_legend_low",
);
export const DASHBOARD_ROAD_TYPE_LEGEND_MED = translatable(
	"dashboard_road_type_legend_med",
);
export const DASHBOARD_ROAD_TYPE_LEGEND_HIGH = translatable(
	"dashboard_road_type_legend_high",
);
export const DASHBOARD_ROAD_TYPE_TOOLTIP_TITLE = translatable(
	"dashboard_road_type_tooltip_title",
);
export const DASHBOARD_ROAD_TYPE_TOOLTIP_COPY = translatable(
	"dashboard_road_type_tooltip_copy",
);
export const DASHBOARD_MILEAGE_TITLE = translatable("dashboard_mileage_title");
export const DASHBOARD_MILEAGE_WEEK_STARTING = translatable(
	"dashboard_mileage_week_starting",
);
export const DASHBOARD_MILEAGE_MONTH = translatable("dashboard_mileage_month");
export const DASHBOARD_COMPARE_MORE_GROUPS = translatable(
	"dashboard_compare_more_groups",
);
export const OSTRICH_MODE_INFO_HEADING = translatable(
	"ostrich_mode_info_heading",
);
export const OSTRICH_MODE_INFO_COPY = translatable("ostrich_mode_info_copy");
export const OSTRICH_MODE_INFO_PILLAR_BOXPLOT_COPY = translatable(
	"ostrich_mode_info_pillar_boxplot_copy",
);
export const INSIGHTS_CATEGORY_NONE_COPY = translatable(
	"insights_category_none_copy",
);
export const INSIGHTS_CATEGORY_GROUP_NONE_COPY = translatable(
	"insights_category_group_none_copy",
);
export const INSIGHTS_GROUP_NONE_COPY = translatable(
	"insights_group_none_copy",
);
export const INSIGHTS_CATEGORY_GROUP_NONE = translatable(
	"insights_category_group_none",
);
export const INSIGHTS_ARCHIVED_NONE = translatable("insights_archived_none");
export const INSIGHTS_VIEW_MORE = translatable("insights_view_more");
export const INSIGHTS_WAS_USEFUL = translatable("insights_was_useful");
export const INSIGHTS_ALL_INSIGHTS = translatable("insights_all_insights");
export const INSIGHTS_ALL_CATEGORIES = translatable("insights_all_categories");
export const INSIGHTS_LATEST_INSIGHTS = translatable(
	"insights_latest_insights",
);
export const INSIGHTS_TYPE_WHATS_NEW_NAME = translatable(
	"insights_type_whats_new_name",
);
export const INSIGHTS_TYPE_FEEDBACK_NAME = translatable(
	"insights_type_feedback_name",
);
export const INSIGHTS_TYPE_GENERAL_NAME = translatable(
	"insights_type_general_name",
);
export const INSIGHTS_DEMO_WARNING = translatable("insights_demo_warning");
export const FILES_IN_FLEET_NONE = translatable("files_in_fleet_none");
export const FILES_UPLOAD_FILE_TO_FOLDER = translatable(
	"files_upload_file_to_folder",
);
export const FILES_GENERATE_FOLDER = translatable("files_generate_folder");
export const FILES_GENERATE_FOLDER_SUBTITLE = translatable(
	"files_generate_folder_subtitle",
);
export const FILES_INVALID_FILE_TYPE = translatable("files_invalid_file_type");
export const FILES_INVALID_FILE_SIZE = translatable("files_invalid_file_size");
export const FILES_CLICK_TO_BROWSE_OR_DROP = translatable(
	"files_click_to_browse_or_drop",
);
export const FILES_DELETE_WARNING_TITLE = translatable(
	"files_delete_warning_title",
);
export const FILES_DELETE_WARNING_SUBTITLE = translatable(
	"files_delete_warning_subtitle",
);
export const PILLAR_WITH_LIVE = translatable("pillar_with_live");
export const PILLAR_LIVE_USERS = translatable("pillar_live_users");
export const PILLAR_LIVE_USERS_PLURAL = translatable(
	"pillar_live_users_plural",
);
export const MISC_OVER = translatable("misc_over");
export const PILLAR_DATA_VIEW_TOOLTIP_CONTENT = translatable(
	"pillar_data_view_tooltip_content",
);
export const PILLAR_DATA_VIEW_DISTANCE_AVERAGE = translatable(
	"pillar_data_view_distance_average",
);
export const PILLAR_IN_LAST_14_DAYS = translatable("pillar_in_last_14_days");
export const PILLAR_ON_AVERAGE_FOR = translatable("pillar_on_average_for");
export const PILLAR_14_DAY_SUMMARY = translatable("pillar_14_day_summary");
export const PILLAR_PERFORMANCE_AND_TRENDS = translatable(
	"pillar_performance_and_trends",
);
export const PILLAR_TRENDS = translatable("pillar_trends");
export const PILLAR_UNIT_EVENT = translatable("pillar_unit_event");
export const PILLAR_UNIT_EVENT_PLURAL = translatable(
	"pillar_unit_event_plural",
);
export const PILLAR_UNIT_DISTRACTION = translatable("pillar_unit_distraction");
export const PILLAR_UNIT_DISTRACTION_PLURAL = translatable(
	"pillar_unit_distraction_plural",
);
export const PILLAR_BENCHMARK_TOOLTIP = translatable(
	"pillar_benchmark_tooltip",
);
export const PILLAR_BENCHMARK_TOOLTIP_EVENTS = translatable(
	"pillar_benchmark_tooltip_events",
);
export const PILLAR_HOTSPOTS_TOO_EARLY = translatable(
	"pillar_hotspots_too_early",
);
export const PILLAR_HOTSPOTS_LOADING = translatable("pillar_hotspots_loading");
export const PILLAR_HOTSPOTS_NO_DATA = translatable("pillar_hotspots_no_data");
export const PILLAR_TOOLTIP_COMPARISON_FLEET = translatable(
	"pillar_tooltip_comparison_fleet",
);
export const PILLAR_TOOLTIP_COMPARISON_DRIVER = translatable(
	"pillar_tooltip_comparison_driver",
);
export const PILLAR_X_AXIS_WEEK_LABEL = translatable(
	"pillar_x_axis_week_label",
);
export const PILLAR_SPEED_NAME = translatable("pillar_speed_name");
export const PILLAR_SPEED_FULL_NAME = translatable("pillar_speed_full_name");
export const PILLAR_SPEED_FULL_NAME_PLURAL = translatable(
	"pillar_speed_full_name_plural",
);
export const PILLAR_SPEED_DESCRIPTION = translatable(
	"pillar_speed_description",
);
export const PILLAR_SPEED_XAXIS_TITLE = translatable(
	"pillar_speed_xaxis_title",
);
export const PILLAR_SPEED_TOOLTIP_TITLE = translatable(
	"pillar_speed_tooltip_title",
);
export const PILLAR_SPEED_TOOLTIP_COPY = translatable(
	"pillar_speed_tooltip_copy",
);
export const PILLAR_SPEED_TOOLTIP_FLEET_COPY = translatable(
	"pillar_speed_tooltip_fleet_copy",
);
export const PILLAR_SPEED_TOOLTIP_DRIVER_COPY = translatable(
	"pillar_speed_tooltip_driver_copy",
);
export const PILLAR_RISK_NAME = translatable("pillar_risk_name");
export const PILLAR_RISK_FULL_NAME = translatable("pillar_risk_full_name");
export const PILLAR_RISK_FULL_NAME_PLURAL = translatable(
	"pillar_risk_full_name_plural",
);
export const PILLAR_RISK_DESCRIPTION = translatable("pillar_risk_description");
export const PILLAR_RISK_XAXIS_TITLE = translatable("pillar_risk_xaxis_title");
export const PILLAR_RISK_TOOLTIP_TITLE = translatable(
	"pillar_risk_tooltip_title",
);
export const PILLAR_RISK_TOOLTIP_COPY = translatable(
	"pillar_risk_tooltip_copy",
);
export const PILLAR_RISK_TOOLTIP_FLEET_COPY = translatable(
	"pillar_risk_tooltip_fleet_copy",
);
export const PILLAR_RISK_TOOLTIP_DRIVER_COPY = translatable(
	"pillar_risk_tooltip_driver_copy",
);
export const PILLAR_ECO_NAME = translatable("pillar_eco_name");
export const PILLAR_ECO_FULL_NAME = translatable("pillar_eco_full_name");
export const PILLAR_ECO_FULL_NAME_PLURAL = translatable(
	"pillar_eco_full_name_plural",
);
export const PILLAR_ECO_DESCRIPTION = translatable("pillar_eco_description");
export const PILLAR_ECO_XAXIS_TITLE = translatable("pillar_eco_xaxis_title");
export const PILLAR_ECO_TOOLTIP_TITLE = translatable(
	"pillar_eco_tooltip_title",
);
export const PILLAR_ECO_TOOLTIP_COPY = translatable("pillar_eco_tooltip_copy");
export const PILLAR_ECO_VIEW_BREAKDOWN = translatable(
	"pillar_eco_view_breakdown",
);
export const PILLAR_FATIGUE_NAME = translatable("pillar_fatigue_name");
export const PILLAR_FATIGUE_FULL_NAME = translatable(
	"pillar_fatigue_full_name",
);
export const PILLAR_FATIGUE_FULL_NAME_PLURAL = translatable(
	"pillar_fatigue_full_name_plural",
);
export const PILLAR_FATIGUE_DESCRIPTION = translatable(
	"pillar_fatigue_description",
);
export const PILLAR_FATIGUE_XAXIS_TITLE = translatable(
	"pillar_fatigue_xaxis_title",
);
export const PILLAR_FATIGUE_UNIT = translatable("pillar_fatigue_unit");
export const PILLAR_FATIGUE_TOOLTIP_TITLE = translatable(
	"pillar_fatigue_tooltip_title",
);
export const PILLAR_FATIGUE_TOOLTIP_COPY = translatable(
	"pillar_fatigue_tooltip_copy",
);
export const PILLAR_FATIGUE_TOOLTIP_FLEET_COPY = translatable(
	"pillar_fatigue_tooltip_fleet_copy",
);
export const PILLAR_FATIGUE_TOOLTIP_DRIVER_COPY = translatable(
	"pillar_fatigue_tooltip_driver_copy",
);
export const PILLAR_DISTRACTION_NAME = translatable("pillar_distraction_name");
export const PILLAR_DISTRACTION_FULL_NAME = translatable(
	"pillar_distraction_full_name",
);
export const PILLAR_DISTRACTION_FULL_NAME_PLURAL = translatable(
	"pillar_distraction_full_name_plural",
);
export const PILLAR_DISTRACTION_DESCRIPTION = translatable(
	"pillar_distraction_description",
);
export const PILLAR_DISTRACTION_XAXIS_TITLE = translatable(
	"pillar_distraction_xaxis_title",
);
export const PILLAR_DISTRACTION_TOOLTIP_TITLE = translatable(
	"pillar_distraction_tooltip_title",
);
export const PILLAR_DISTRACTION_TOOLTIP_COPY = translatable(
	"pillar_distraction_tooltip_copy",
);
export const SINGLE_SCORE_CONTENT_TITLE = translatable(
	"single_score_content_title",
);
export const SINGLE_SCORE_NAME = translatable("single_score_name");
export const SINGLE_SCORE_XAXIS_TITLE = translatable(
	"single_score_xaxis_title",
);
export const SINGLE_SCORE_TOOLTIP_TITLE = translatable(
	"single_score_tooltip_title",
);
export const SINGLE_SCORE_TOOLTIP_COPY = translatable(
	"single_score_tooltip_copy",
);
export const PILLAR_HW_SPEED_NAME = translatable("pillar_hw_speed_name");
export const PILLAR_HW_EXCESSIVE_SPEED_NAME = translatable(
	"pillar_hw_excessive_speed_name",
);
export const PILLAR_HW_EXCESSIVE_SPEED_SCORE = translatable(
	"pillar_hw_excessive_speed_score",
);
export const PILLAR_HW_SEATBELT_NAME = translatable("pillar_hw_seatbelt_name");
export const PILLAR_HW_ACCELERATION_NAME = translatable(
	"pillar_hw_acceleration_name",
);
export const PILLAR_HW_BRAKING_NAME = translatable("pillar_hw_braking_name");
export const PILLAR_HW_CORNERING_NAME = translatable(
	"pillar_hw_cornering_name",
);
export const PILLAR_VIEW_BREAKDOWN = translatable("pillar_view_breakdown");
export const HW_PILLAR_XAXIS_TITLE = translatable("hw_pillar_xaxis_title");
export const ONBOARDING_CTA_SHOW_AROUND = translatable(
	"onboarding_cta_show_around",
);
export const ONBOARDING_CTA_START_EXPLORING = translatable(
	"onboarding_cta_start_exploring",
);
export const ONBOARDING_CTA_KEEP_EXPLORING = translatable(
	"onboarding_cta_keep_exploring",
);
export const ONBOARDING_DRIVER_TOOLTIP_TITLE = translatable(
	"onboarding_driver_tooltip_title",
);
export const ONBOARDING_DRIVER_TOOLTIP_COPY = translatable(
	"onboarding_driver_tooltip_copy",
);
export const ONBOARDING_DASHBOARD_CTA_EXPLAIN = translatable(
	"onboarding_dashboard_cta_explain",
);
export const ONBOARDING_DASHBOARD_CTA_SKIP = translatable(
	"onboarding_dashboard_cta_skip",
);
export const ONBOARDING_DASHBOARD_STEP_1_TITLE = translatable(
	"onboarding_dashboard_step_1_title",
);
export const ONBOARDING_DASHBOARD_STEP_1_COPY = translatable(
	"onboarding_dashboard_step_1_copy",
);
export const ONBOARDING_DASHBOARD_STEP_2_TITLE = translatable(
	"onboarding_dashboard_step_2_title",
);
export const ONBOARDING_DASHBOARD_STEP_2_COPY = translatable(
	"onboarding_dashboard_step_2_copy",
);
export const ONBOARDING_DASHBOARD_STEP_2_IMAGE_OVERLAY = translatable(
	"onboarding_dashboard_step_2_image_overlay",
);
export const ONBOARDING_DASHBOARD_STEP_3_TITLE = translatable(
	"onboarding_dashboard_step_3_title",
);
export const ONBOARDING_DASHBOARD_STEP_3_COPY = translatable(
	"onboarding_dashboard_step_3_copy",
);
export const ONBOARDING_DASHBOARD_STEP_3_IMAGE_OVERLAY = translatable(
	"onboarding_dashboard_step_3_image_overlay",
);
export const ONBOARDING_DASHBOARD_STEP_4_TITLE = translatable(
	"onboarding_dashboard_step_4_title",
);
export const ONBOARDING_DASHBOARD_STEP_4_COPY = translatable(
	"onboarding_dashboard_step_4_copy",
);
export const ONBOARDING_DASHBOARD_STEP_4_IMAGE_OVERLAY = translatable(
	"onboarding_dashboard_step_4_image_overlay",
);
export const ONBOARDING_DASHBOARD_STEP_5_TITLE = translatable(
	"onboarding_dashboard_step_5_title",
);
export const ONBOARDING_DASHBOARD_STEP_5_COPY = translatable(
	"onboarding_dashboard_step_5_copy",
);
export const ONBOARDING_DASHBOARD_STEP_5_IMAGE_OVERLAY = translatable(
	"onboarding_dashboard_step_5_image_overlay",
);
export const ONBOARDING_DASHBOARD_STEP_6_TITLE = translatable(
	"onboarding_dashboard_step_6_title",
);
export const ONBOARDING_DASHBOARD_STEP_6_COPY = translatable(
	"onboarding_dashboard_step_6_copy",
);
export const ONBOARDING_DASHBOARD_STEP_6_IMAGE_OVERLAY = translatable(
	"onboarding_dashboard_step_6_image_overlay",
);
export const ONBOARDING_DRIVERS_INDEX_STEP_1_TITLE = translatable(
	"onboarding_drivers_index_step_1_title",
);
export const ONBOARDING_DRIVERS_INDEX_STEP_1_SUBHEADING = translatable(
	"onboarding_drivers_index_step_1_subheading",
);
export const ONBOARDING_DRIVERS_INDEX_STEP_1_COPY = translatable(
	"onboarding_drivers_index_step_1_copy",
);
export const ONBOARDING_DRIVER_PROFILE_STEP_1_TITLE = translatable(
	"onboarding_driver_profile_step_1_title",
);
export const ONBOARDING_DRIVER_PROFILE_STEP_1_SUBHEADING = translatable(
	"onboarding_driver_profile_step_1_subheading",
);
export const ONBOARDING_DRIVER_PROFILE_STEP_1_COPY = translatable(
	"onboarding_driver_profile_step_1_copy",
);
export const ALERT_CURVE_DESCRIPTION = translatable("alert_curve_description");
export const ALERT_WINDING_ROAD_DESCRIPTION = translatable(
	"alert_winding_road_description",
);
export const ALERT_NARROW_ROAD_DESCRIPTION = translatable(
	"alert_narrow_road_description",
);
export const ALERT_HILL_DESCRIPTION = translatable("alert_hill_description");
export const ALERT_LANE_MERGE_DESCRIPTION = translatable(
	"alert_lane_merge_description",
);
export const ALERT_PRIORITY_TO_ONCOMING_TRAFFIC_DESCRIPTION = translatable(
	"alert_priority_to_oncoming_traffic_description",
);
export const ALERT_STOP_SIGN_DESCRIPTION = translatable(
	"alert_stop_sign_description",
);
export const ALERT_TRAFFIC_LIGHT_DESCRIPTION = translatable(
	"alert_traffic_light_description",
);
export const ALERT_YIELD_DESCRIPTION = translatable("alert_yield_description");
export const ALERT_PEDESTRIAN_CROSSING_DESCRIPTION = translatable(
	"alert_pedestrian_crossing_description",
);
export const ALERT_RAILWAY_CROSSING_DESCRIPTION = translatable(
	"alert_railway_crossing_description",
);
export const ALERT_TRAMWAY_CROSSING_DESCRIPTION = translatable(
	"alert_tramway_crossing_description",
);
export const ALERT_SCHOOL_ZONE_DESCRIPTION = translatable(
	"alert_school_zone_description",
);
export const ALERT_ANIMAL_CROSSING_DESCRIPTION = translatable(
	"alert_animal_crossing_description",
);
export const ALERT_CAUTION_DESCRIPTION = translatable(
	"alert_caution_description",
);
export const ALERT_SLIPPERY_ROADS_DESCRIPTION = translatable(
	"alert_slippery_roads_description",
);
export const ALERT_ACCIDENT_DESCRIPTION = translatable(
	"alert_accident_description",
);
export const ALERT_CONGESTION_DESCRIPTION = translatable(
	"alert_congestion_description",
);
export const ALERT_INTERSECTION_DESCRIPTION = translatable(
	"alert_intersection_description",
);
export const ALERT_CURVE_NAME = translatable("alert_curve_name");
export const ALERT_WINDING_ROAD_NAME = translatable("alert_winding_road_name");
export const ALERT_NARROW_ROAD_NAME = translatable("alert_narrow_road_name");
export const ALERT_HILL_NAME = translatable("alert_hill_name");
export const ALERT_LANE_MERGE_NAME = translatable("alert_lane_merge_name");
export const ALERT_PRIORITY_TO_ONCOMING_TRAFFIC_NAME = translatable(
	"alert_priority_to_oncoming_traffic_name",
);
export const ALERT_STOP_SIGN_NAME = translatable("alert_stop_sign_name");
export const ALERT_TRAFFIC_LIGHT_NAME = translatable(
	"alert_traffic_light_name",
);
export const ALERT_YIELD_NAME = translatable("alert_yield_name");
export const ALERT_PEDESTRIAN_CROSSING_NAME = translatable(
	"alert_pedestrian_crossing_name",
);
export const ALERT_RAILWAY_CROSSING_NAME = translatable(
	"alert_railway_crossing_name",
);
export const ALERT_TRAMWAY_CROSSING_NAME = translatable(
	"alert_tramway_crossing_name",
);
export const ALERT_SCHOOL_ZONE_NAME = translatable("alert_school_zone_name");
export const ALERT_ANIMAL_CROSSING_NAME = translatable(
	"alert_animal_crossing_name",
);
export const ALERT_CAUTION_NAME = translatable("alert_caution_name");
export const ALERT_SLIPPERY_ROADS_NAME = translatable(
	"alert_slippery_roads_name",
);
export const ALERT_ACCIDENT_NAME = translatable("alert_accident_name");
export const ALERT_CONGESTION_NAME = translatable("alert_congestion_name");
export const ALERT_NO_OVERTAKING_TRUCKS_NAME = translatable(
	"alert_no_overtaking_trucks_name",
);
export const ALERT_NO_OVERTAKING_NAME = translatable(
	"alert_no_overtaking_name",
);
export const ALERT_INTERSECTION_NAME = translatable("alert_intersection_name");
export const BOX_PLOT_PERFECT_SCORE = translatable("box_plot_perfect_score");
export const BOX_PLOT_NOT_ENOUGH_DATA = translatable(
	"box_plot_not_enough_data",
);
export const BOX_PLOT_WORST_DRIVERS = translatable("box_plot_worst_drivers");
export const BOX_PLOT_BEST_DRIVERS = translatable("box_plot_best_drivers");
export const BOX_PLOT_AVERAGE_DRIVERS = translatable(
	"box_plot_average_drivers",
);
export const BOX_PLOT_TOOLTIP_TITLE = translatable("box_plot_tooltip_title");
export const BOX_PLOT_TOOLTIP_COPY = translatable("box_plot_tooltip_copy");
export const BOX_PLOT_TOOLTIP_BAD_OUTLIERS_TITLE = translatable(
	"box_plot_tooltip_bad_outliers_title",
);
export const BOX_PLOT_TOOLTIP_BAD_OUTLIERS_COPY = translatable(
	"box_plot_tooltip_bad_outliers_copy",
);
export const BOX_PLOT_TOOLTIP_FLEET_PERFORMANCE_OUTLIERS_TITLE = translatable(
	"box_plot_tooltip_fleet_performance_outliers_title",
);
export const BOX_PLOT_TOOLTIP_FLEET_PERFORMANCE_OUTLIERS_COPY = translatable(
	"box_plot_tooltip_fleet_performance_outliers_copy",
);
export const BOX_PLOT_TOOLTIP_GOOD_OUTLIERS_TITLE = translatable(
	"box_plot_tooltip_good_outliers_title",
);
export const BOX_PLOT_TOOLTIP_GOOD_OUTLIERS_COPY = translatable(
	"box_plot_tooltip_good_outliers_copy",
);
export const BOX_PLOT_NOT_ENOUGH_DRIVERS = translatable(
	"box_plot_not_enough_drivers",
);
export const BOX_PLOT_OUTLIER_WEEK_STARTING = translatable(
	"box_plot_outlier_week_starting",
);
export const PROGRAM_USING_BRIGHTMILE = translatable(
	"program_using_brightmile",
);
export const PROGRAM_ACCESS_MORE_FLEETS = translatable(
	"program_access_more_fleets",
);
export const STATUS_BAR_ANONYMOUS_MODE = translatable(
	"status_bar_anonymous_mode",
);
export const STATUS_BAR_DEMO_MODE = translatable("status_bar_demo_mode");
export const CHANGE_PASSWORD_UPDATED = translatable("change_password_updated");
export const CHANGE_PASSWORD_NOT_UPDATED = translatable(
	"change_password_not_updated",
);
export const CHANGE_PASSWORD_WRONG_PASSWORD = translatable(
	"change_password_wrong_password",
);
export const CHANGE_PASSWORD_CANNOT_MATCH = translatable(
	"change_password_cannot_match",
);
export const CHANGE_PASSWORD_TOO_MANY_ATTEMPTS = translatable(
	"change_password_too_many_attempts",
);
export const LEGAL_PRIVACY_POLICY_PORTAL_TITLE = translatable(
	"legal_privacy_policy_portal_title",
);
export const NOTIFICATION_CHRISTMAS = translatable("notification_christmas");
export const DRIVERS_EXPORT = translatable("drivers_export");
export const DRIVERS_SIGNED_UP = translatable("drivers_signed_up");
export const INVITE_EMAIL_SUBJECT = translatable("invite_email_subject");
export const INVITE_EMAIL_COPY = translatable("invite_email_copy");
export const INACTIVE_EMAIL_SUBJECT = translatable("inactive_email_subject");
export const INACTIVE_EMAIL_COPY = translatable("inactive_email_copy");
export const SPLASH_NOTIFICATION_LEVEL_1_HEADLINE = translatable(
	"splash_notification_level_1_headline",
);
export const SPLASH_NOTIFICATION_LEVEL_2_HEADLINE = translatable(
	"splash_notification_level_2_headline",
);
export const ADVANCED_SEARCH_SHOW_FILTERS = translatable(
	"advanced_search_show_filters",
);
export const ADVANCED_SEARCH_WITHOUT_SUB_OPTS = translatable(
	"advanced_search_without_sub_opts",
);
export const ADVANCED_SEARCH_GROUPS_PLACEHOLDER = translatable(
	"advanced_search_groups_placeholder",
);
export const PPT_TITLE_SLIDE = translatable("ppt_title_slide");
export const PPT_CHARACTERISTICS_TITLE = translatable(
	"ppt_characteristics_title",
);
export const PPT_TRENDS_TITLE = translatable("ppt_trends_title");
export const PPT_SUMMARY_TITLE = translatable("ppt_summary_title");
export const MISC_TRY_AGAIN_LATER = translatable("misc_try_again_later");
export const MULTI_FACTOR_FACTOR_REMOVE = translatable(
	"multi_factor_factor_remove",
);
export const MULTI_FACTOR_FACTOR_EDIT = translatable(
	"multi_factor_factor_edit",
);
export const MULTI_FACTOR_FACTOR_ADD = translatable("multi_factor_factor_add");
export const MULTI_FACTOR_CURRENTLY_ENABLED = translatable(
	"multi_factor_currently_enabled",
);
export const MULTI_FACTOR_FACTOR_TYPE_PHONE = translatable(
	"multi_factor_factor_type_phone",
);
export const MULTI_FACTOR_ACTION_SEND_VERIFY_CODE = translatable(
	"multi_factor_action_send_verify_code",
);
export const MULTI_FACTOR_ACTION_VERIFY_CODE = translatable(
	"multi_factor_action_verify_code",
);
export const MULTI_FACTOR_RECEIVE_TEXT = translatable(
	"multi_factor_receive_text",
);
export const MULTI_FACTOR_PHONE_CODE = translatable("multi_factor_phone_code");
export const MULTI_FACTOR_PASSWORD_AUTH_COPY = translatable(
	"multi_factor_password_auth_copy",
);
export const MULTI_FACTOR_MANDATE_COPY = translatable(
	"multi_factor_mandate_copy",
);
export const MULTI_FACTOR_TRY_AGAIN = translatable("multi_factor_try_again");
export const COMPARE_TITLE = translatable("compare_title");
export const COMPARE_TOGGLE_GRAPH = translatable("compare_toggle_graph");
export const COMPARE_TOGGLE_TABLE = translatable("compare_toggle_table");
export const COMPARE_SHOW_LEGEND = translatable("compare_show_legend");
export const COMPARE_EDIT_GROUPS = translatable("compare_edit_groups");
export const COMPARE_GROUPS_DISPLAYED_PLURAL = translatable(
	"compare_groups_displayed_plural",
);
export const COMPARE_GROUPS_DISPLAYED_SINGULAR = translatable(
	"compare_groups_displayed_singular",
);
export const COMPARE_DRIVERS_DISPLAYED_PLURAL = translatable(
	"compare_drivers_displayed_plural",
);
export const COMPARE_DRIVERS_DISPLAYED_SINGULAR = translatable(
	"compare_drivers_displayed_singular",
);
export const COMPARE_OPT_GROUPS = translatable("compare_opt_groups");
export const COMPARE_OPT_USERS = translatable("compare_opt_users");
export const COMPARE_DRIVER_FILTER_PLACEHOLDER = translatable(
	"compare_driver_filter_placeholder",
);
export const COMPARE_RESTRICTED_DRIVERS_HEADING_PLURAL = translatable(
	"compare_restricted_drivers_heading_plural",
);
export const COMPARE_RESTRICTED_DRIVERS_HEADING_SINGULAR = translatable(
	"compare_restricted_drivers_heading_singular",
);
export const COMPARE_RESTRICTED_DRIVERS_COPY = translatable(
	"compare_restricted_drivers_copy",
);
export const COMPARE_MIN_GROUP_SELECT = translatable(
	"compare_min_group_select",
);
export const COMPARE_SHOW_TARGET_LINE = translatable(
	"compare_show_target_line",
);
export const LEGAL_APP_POLICIES_TITLE = translatable(
	"legal_app_policies_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_TITLE = translatable(
	"auth_action_verify_email_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_COPY = translatable(
	"auth_action_verify_email_copy",
);
export const AUTH_ACTION_VERIFY_EMAIL_RETRY_TITLE = translatable(
	"auth_action_verify_email_retry_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_LOADING_TITLE = translatable(
	"auth_action_verify_email_loading_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_SUCCESS_TITLE = translatable(
	"auth_action_verify_email_success_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_SUCCESS_ALREADY_TITLE = translatable(
	"auth_action_verify_email_success_already_title",
);
export const AUTH_ACTION_VERIFY_EMAIL_SUCCESS_COPY = translatable(
	"auth_action_verify_email_success_copy",
);
export const AUTH_ACTION_VERIFY_EMAIL_EXPIRED = translatable(
	"auth_action_verify_email_expired",
);
export const AUTH_ACTION_VERIFY_INVALID_ACCOUNT_TITLE = translatable(
	"auth_action_verify_invalid_account_title",
);
export const AUTH_ACTION_VERIFY_INVALID_ACCOUNT_COPY = translatable(
	"auth_action_verify_invalid_account_copy",
);
export const AUTH_ACTION_RESET_PASSWORD_TITLE = translatable(
	"auth_action_reset_password_title",
);
export const AUTH_ACTION_RESET_PASSWORD_COPY = translatable(
	"auth_action_reset_password_copy",
);
export const AUTH_ACTION_RESET_PASSWORD_EXPIRED = translatable(
	"auth_action_reset_password_expired",
);
export const AUTH_ACTION_RESET_PASSWORD_SUCCESS_TITLE = translatable(
	"auth_action_reset_password_success_title",
);
export const AUTH_ACTION_RESET_PASSWORD_SUCCESS_COPY = translatable(
	"auth_action_reset_password_success_copy",
);
export const AUTH_ACTION_RESET_PASSWORD_FAIL_TITLE = translatable(
	"auth_action_reset_password_fail_title",
);
export const AUTH_ACTION_RESET_PASSWORD_RETRY_TITLE = translatable(
	"auth_action_reset_password_retry_title",
);
export const AUTH_ACTION_RESET_PASSWORD_MUST_MATCH = translatable(
	"auth_action_reset_password_must_match",
);
export const MISC_PASSWORD = translatable("misc_password");
export const MISC_TRY_AGAIN_QUESTION = translatable("misc_try_again_question");
export const PROFILE_PASSWORD_RETYPE_PASSWORD = translatable(
	"profile_password_retype_password",
);
export const FORM_SUBMITTING = translatable("form_submitting");
export const FORM_ERROR_PASSWORD = translatable("form_error_password");
export const SPLASH_TAG_LINE = translatable("splash_tag_line");
export const AUTH_ACTION_PORTAL_LOGIN = translatable(
	"auth_action_portal_login",
);
export const AUTH_LOGIN_UNSUCCESSFUL_ERROR = translatable(
	"auth_login_unsuccessful_error",
);
export const AUTH_MULTI_FACTOR_ERROR = translatable("auth_multi_factor_error");
export const AUTH_MULTI_FACTOR_EXPIRED = translatable(
	"auth_multi_factor_expired",
);
export const MISC_NEXT_PAGE = translatable("misc_next_page");
export const MISC_PREVIOUS_PAGE = translatable("misc_previous_page");
export const EXPORT_PDF = translatable("export_pdf");
export const EXPORT_IMAGE = translatable("export_image");
export const EXPORT_PPT = translatable("export_ppt");
export const EXPORT_CSV = translatable("export_csv");
export const EXPORT_EXCEL = translatable("export_excel");
export const SUB_PILLAR_HARSH_ACCELERATION_NAME = translatable(
	"sub_pillar_harsh_acceleration_name",
);
export const SUB_PILLAR_HARSH_ACCELERATION_XAXIS_TITLE = translatable(
	"sub_pillar_harsh_acceleration_xaxis_title",
);
export const SUB_PILLAR_HARSH_ACCELERATION_FULL_NAME = translatable(
	"sub_pillar_harsh_acceleration_full_name",
);
export const SUB_PILLAR_HARSH_ACCELERATION_FULL_NAME_PLURAL = translatable(
	"sub_pillar_harsh_acceleration_full_name_plural",
);
export const SUB_PILLAR_HARSH_BRAKING_NAME = translatable(
	"sub_pillar_harsh_braking_name",
);
export const SUB_PILLAR_HARSH_BRAKING_XAXIS_TITLE = translatable(
	"sub_pillar_harsh_braking_xaxis_title",
);
export const SUB_PILLAR_HARSH_BRAKING_FULL_NAME = translatable(
	"sub_pillar_harsh_braking_full_name",
);
export const SUB_PILLAR_HARSH_BRAKING_FULL_NAME_PLURAL = translatable(
	"sub_pillar_harsh_braking_full_name_plural",
);
export const SUB_PILLAR_HARSH_BRAKING_TOOLTIP_COPY = translatable(
	"sub_pillar_harsh_braking_tooltip_copy",
);
export const TIME_RANGE_4_WEEKS = translatable("time_range_4_weeks");
export const TIME_RANGE_2_MONTHS = translatable("time_range_2_months");
export const TIME_RANGE_3_MONTHS = translatable("time_range_3_months");
export const TIME_RANGE_6_MONTHS = translatable("time_range_6_months");
export const TIME_RANGE_12_MONTHS = translatable("time_range_12_months");
export const TIME_RANGE_WEEK = translatable("time_range_week");
export const TIME_RANGE_MONTH = translatable("time_range_month");
export const LEADERBOARDS_ACTIVE_LEADERBOARDS = translatable(
	"leaderboards_active_leaderboards",
);
export const LEADERBOARDS_PREVIOUS_LEADERBOARDS = translatable(
	"leaderboards_previous_leaderboards",
);
export const LEADERBOARDS_DRIVER_LEADERBOARD_NAME = translatable(
	"leaderboards_driver_leaderboard_name",
);
export const LEADERBOARDS_TEAM_LEADERBOARD_NAME = translatable(
	"leaderboards_team_leaderboard_name",
);
export const LEADERBOARDS_HEADER_NAME = translatable(
	"leaderboards_header_name",
);
export const LEADERBOARDS_HEADER_PERIOD = translatable(
	"leaderboards_header_period",
);
export const LEADERBOARDS_HEADER_TEAMS = translatable(
	"leaderboards_header_teams",
);
export const LEADERBOARDS_HEADER_TOTAL_DRIVERS = translatable(
	"leaderboards_header_total_drivers",
);
export const LEADERBOARDS_HEADER_FIRST = translatable(
	"leaderboards_header_first",
);
export const LEADERBOARDS_HEADER_WINNER = translatable(
	"leaderboards_header_winner",
);
export const LEADERBOARD_DRIVER_EXPORT_NAME = translatable(
	"leaderboard_driver_export_name",
);
export const LEADERBOARD_TEAM_EXPORT_NAME = translatable(
	"leaderboard_team_export_name",
);
export const LEADERBOARD_RANKINGS_MENU_LIST = translatable(
	"leaderboard_rankings_menu_list",
);
export const LEADERBOARD_RANKINGS_MENU_TOP_3 = translatable(
	"leaderboard_rankings_menu_top_3",
);
export const LEADERBOARD_RANKINGS_MENU_TOP_5 = translatable(
	"leaderboard_rankings_menu_top_5",
);
export const LEADERBOARD_RANKINGS_MENU_TOP_10 = translatable(
	"leaderboard_rankings_menu_top_10",
);
export const LEADERBOARD_RANKINGS_BACK_TO_LEADERBOARDS = translatable(
	"leaderboard_rankings_back_to_leaderboards",
);
export const LEADERBOARD_TABLE_TOTAL_TEAMS = translatable(
	"leaderboard_table_total_teams",
);
export const LEADERBOARD_TABLE_TOTAL_DRIVERS = translatable(
	"leaderboard_table_total_drivers",
);
export const LEADERBOARDS_TABLE_NAME = translatable("leaderboards_table_name");
export const LEADERBOARDS_TABLE_DRIVER_NAME = translatable(
	"leaderboards_table_driver_name",
);
export const LEADERBOARDS_TABLE_TEAM_NAME = translatable(
	"leaderboards_table_team_name",
);
export const LEADERBOARDS_TABLE_RANK = translatable("leaderboards_table_rank");
export const LEADERBOARDS_TABLE_DRIVING_SCORE = translatable(
	"leaderboards_table_driving_score",
);
export const LEADERBOARDS_FLYER_DRIVER_TITLE = translatable(
	"leaderboards_flyer_driver_title",
);
export const LEADERBOARDS_FLYER_TEAM_TITLE = translatable(
	"leaderboards_flyer_team_title",
);
export const LEADERBOARDS_FLYER_TEAM_TITLE_5 = translatable(
	"leaderboards_flyer_team_title_5",
);
export const LEADERBOARDS_FLYER_TEAM_TITLE_10 = translatable(
	"leaderboards_flyer_team_title_10",
);
export const LEADERBOARDS_FLYER_HEADING = translatable(
	"leaderboards_flyer_heading",
);
export const LEADERBOARDS_TYPE_DRIVER = translatable(
	"leaderboards_type_driver",
);
export const LEADERBOARDS_TYPE_TEAM = translatable("leaderboards_type_team");
export const MISC_LOAD_MORE = translatable("misc_load_more");
export const DRIVER_TRIPS_SELECT_DATES = translatable(
	"driver_trips_select_dates",
);
export const DRIVER_TRIPS_FOUND = translatable("driver_trips_found");
export const DRIVER_TRIPS_HIDE_CALENDAR = translatable(
	"driver_trips_hide_calendar",
);
export const DRIVER_TRIPS_CHANGE_DATE_SELECTION = translatable(
	"driver_trips_change_date_selection",
);
export const DRIVER_TRIPS_RELOAD = translatable("driver_trips_reload");
export const DRIVER_TRIPS_TRIP_START_TIME = translatable(
	"driver_trips_trip_start_time",
);
export const DRIVER_TRIPS_TRIP_END_TIME = translatable(
	"driver_trips_trip_end_time",
);
export const DRIVER_TRIPS_TRIP_DURATION = translatable(
	"driver_trips_trip_duration",
);
export const DRIVER_TRIPS_TRIP_DISTANCE = translatable(
	"driver_trips_trip_distance",
);
export const DRIVER_TRIPS_TRIP_START_LOCATION = translatable(
	"driver_trips_trip_start_location",
);
export const DRIVER_TRIPS_TRIP_END_LOCATION = translatable(
	"driver_trips_trip_end_location",
);
export const DRIVER_TRIPS_TRIP_ID = translatable("driver_trips_trip_id");
export const DRIVER_TRIPS_TRIP_DEVICE = translatable(
	"driver_trips_trip_device",
);
export const DRIVER_TRIPS_TRIP_OS = translatable("driver_trips_trip_os");
export const DRIVER_TRIPS_TRIP_APP_VERSION = translatable(
	"driver_trips_trip_app_version",
);
export const DRIVER_TRIPS_TRIP_TRIP_DETAILS_HEADING = translatable(
	"driver_trips_trip_trip_details_heading",
);
export const DRIVER_TRIPS_TRIP_TECHNICAL_DETAILS_HEADING = translatable(
	"driver_trips_trip_technical_details_heading",
);
export const DRIVER_TRIPS_EXPORT_TRIP = translatable(
	"driver_trips_export_trip",
);
export const MISC_SCORE_PLURAL = translatable("misc_score_plural");
export const DRIVER_PROFILE_MENU_ITEM_DASHBOARD = translatable(
	"driver_profile_menu_item_dashboard",
);
export const DRIVER_PROFILE_MENU_ITEM_TRIPS = translatable(
	"driver_profile_menu_item_trips",
);
export const REPORTS_FILLED_IN_FAILED = translatable(
	"reports_filled_in_failed",
);
export const REPORTS_FILLED_IN_FAILED_TOOLTIP_TITLE = translatable(
	"reports_filled_in_failed_tooltip_title",
);
export const REPORTS_FILLED_IN_FAILED_TOOLTIP_BODY = translatable(
	"reports_filled_in_failed_tooltip_body",
);
export const REPORTS_FILLED_IN_SUCCEEDED = translatable(
	"reports_filled_in_succeeded",
);
export const REPORTS_FILLED_IN_SUCCEEDED_TOOLTIP_TITLE = translatable(
	"reports_filled_in_succeeded_tooltip_title",
);
export const REPORTS_FILLED_IN_SUCCEEDED_TOOLTIP_BODY = translatable(
	"reports_filled_in_succeeded_tooltip_body",
);
export const REPORTS_FILLED_IN = translatable("reports_filled_in");
export const REPORTS_FILLED_IN_TOOLTIP_TITLE = translatable(
	"reports_filled_in_tooltip_title",
);
export const REPORTS_FILLED_IN_TOOLTIP_BODY = translatable(
	"reports_filled_in_tooltip_body",
);
export const REPORTS_VEHICLE_CHECKS = translatable("reports_vehicle_checks");
export const REPORTS_VEHICLE_CHECKS_REPORT = translatable(
	"reports_vehicle_checks_report",
);
export const REPORTS_GROUP_RANKINGS = translatable("reports_group_rankings");
export const REPORTS_RANKINGS_FIRST_SELECTION = translatable(
	"reports_rankings_first_selection",
);
export const REPORTS_RANKINGS_INFO = translatable("reports_rankings_info");
export const REPORTS_RANKINGS_RELOAD = translatable("reports_rankings_reload");
export const REPORTS_RANKINGS_MONTHLY = translatable(
	"reports_rankings_monthly",
);
export const REPORTS_RANKINGS_WEEKLY = translatable("reports_rankings_weekly");
export const REPORTS_RANKINGS_PERIOD = translatable("reports_rankings_period");
export const REPORTS_GROUP_RANKINGS_REPORT = translatable(
	"reports_group_rankings_report",
);
export const REPORTS_USER_RANKINGS = translatable("reports_user_rankings");
export const REPORTS_USER_RANKINGS_REPORT = translatable(
	"reports_user_rankings_report",
);
export const REPORTS_DRIVER_RANKINGS_EVENTS_REPORT = translatable(
	"reports_driver_rankings_events_report",
);
export const REPORTS_GROUP_RANKINGS_EVENTS_REPORT = translatable(
	"reports_group_rankings_events_report",
);
export const REPORTS_TITLE = translatable("reports_title");
export const REPORTS_TOGGLE_OVERVIEW = translatable("reports_toggle_overview");
export const REPORTS_TOGGLE_ALL_CHECKS = translatable(
	"reports_toggle_all_checks",
);
export const REPORTS_TOGGLE_CHECKS_PER_WEEK = translatable(
	"reports_toggle_checks_per_week",
);
export const REPORTS_NOT_FILLED_IN = translatable("reports_not_filled_in");
export const REPORTS_NOT_FILLED_IN_TOOLTIP_TITLE = translatable(
	"reports_not_filled_in_tooltip_title",
);
export const REPORTS_NOT_FILLED_IN_TOOLTIP_BODY = translatable(
	"reports_not_filled_in_tooltip_body",
);
export const REPORTS_CHARTS_COMPLETION_HEADING = translatable(
	"reports_charts_completion_heading",
);
export const REPORTS_CHARTS_PASS_HEADING = translatable(
	"reports_charts_pass_heading",
);
export const REPORTS_CHARTS_LABEL = translatable("reports_charts_label");
export const NAVIGATION_REPORTS = translatable("navigation_reports");
export const REPORTS_VIEW_REPORT = translatable("reports_view_report");
export const REPORTS_MONTHLY_WEEKLY_PERIOD = translatable(
	"reports_monthly_weekly_period",
);
export const REPORTS_CUSTOM_WEEKLY_PERIOD = translatable(
	"reports_custom_weekly_period",
);
export const REPORTS_PREVIOUS_WEEK = translatable("reports_previous_week");
export const REPORTS_NEXT_WEEK = translatable("reports_next_week");
export const REPORTS_NONE = translatable("reports_none");
export const REPORTS_FROM = translatable("reports_from");
export const REPORTS_TO = translatable("reports_to");
export const REPORTS_DATE = translatable("reports_date");
export const REPORTS_WEEK_STARTING_FROM = translatable(
	"reports_week_starting_from",
);
export const REPORTS_MONTH_STARTING_FROM = translatable(
	"reports_month_starting_from",
);
export const REPORTS_PASSED = translatable("reports_passed");
export const REPORTS_FAILED = translatable("reports_failed");
export const REPORTS_INCOMPLETE = translatable("reports_incomplete");
export const REPORTS_FIRST_NAME = translatable("reports_first_name");
export const REPORTS_LAST_NAME = translatable("reports_last_name");
export const REPORTS_STATUS = translatable("reports_status");
export const REPORTS_GROUP = translatable("reports_group");
export const REPORTS_GROUPS = translatable("reports_groups");
export const REPORTS_GROUP_NAME = translatable("reports_group_name");
export const REPORTS_VEHICLE_REG = translatable("reports_vehicle_reg");
export const REPORTS_SUBMISSION_DATE = translatable("reports_submission_date");
export const REPORTS_FORM_DATA = translatable("reports_form_data");
export const REPORTS_EMAIL = translatable("reports_email");
export const REPORTS_FLEET_NAME = translatable("reports_fleet_name");
export const REPORTS_TRIPS_COUNT = translatable("reports_trips_count");
export const REPORTS_TOTAL_DISTANCE = translatable("reports_total_distance");
export const REPORTS_DRIVING_SCORE = translatable("reports_driving_score");
export const REPORTS_RISK = translatable("reports_risk");
export const REPORTS_SPEEDING = translatable("reports_speeding");
export const REPORTS_DISTRACTION = translatable("reports_distraction");
export const REPORTS_FATIGUE = translatable("reports_fatigue");
export const REPORTS_ECO = translatable("reports_eco");
export const REPORTS_HARSH_ACCELERATION = translatable(
	"reports_harsh_acceleration",
);
export const REPORTS_HARSH_BRAKING = translatable("reports_harsh_braking");
export const LEADERBOARDS_NO_ACTIVE_BOARDS = translatable(
	"leaderboards_no_active_boards",
);
export const LEADERBOARDS_NO_PREVIOUS_BOARDS = translatable(
	"leaderboards_no_previous_boards",
);
export const LEADERBOARDS_VIEW_ANOTHER_GROUP = translatable(
	"leaderboards_view_another_group",
);
export const LEADERBOARDS_MENU_TITLE = translatable("leaderboards_menu_title");
export const MISC_SELECT = translatable("misc_select");
export const SELECT_DATE_RANGE = translatable("select_date_range");
export const DRIVER_TRIPS_POI_TYPE_START = translatable(
	"driver_trips_poi_type_start",
);
export const DRIVER_TRIPS_POI_TYPE_FINISH = translatable(
	"driver_trips_poi_type_finish",
);
export const DRIVER_TRIPS_POI_TOOLTIP_PERCENTAGE_OVER = translatable(
	"driver_trips_poi_tooltip_percentage_over",
);
export const DRIVER_TRIPS_POI_TOOLTIP_TRAFFIC_SIGN = translatable(
	"driver_trips_poi_tooltip_traffic_sign",
);
export const DRIVER_TRIPS_POI_TOOLTIP_SPEED = translatable(
	"driver_trips_poi_tooltip_speed",
);
export const DRIVER_TRIPS_POI_TOOLTIP_SPEED_LIMIT = translatable(
	"driver_trips_poi_tooltip_speed_limit",
);
export const DRIVER_TRIPS_POI_TOOLTIP_SPEED_LIMIT_THRESHOLD = translatable(
	"driver_trips_poi_tooltip_speed_limit_threshold",
);
export const EVENT_VIEW_SPEED_LIMIT = translatable("EVENT_VIEW_SPEED_LIMIT");
export const EVENT_VIEW_SPEED_THRESHOLD = translatable(
	"EVENT_VIEW_SPEED_THRESHOLD",
);
export const POI_CODE_02_ANIMAL_CROSSING = translatable(
	"POI_CODE_02_ANIMAL_CROSSING",
);
export const POI_CODE_05_CURVE = translatable("POI_CODE_05_CURVE");
export const POI_CODE_06_HILL = translatable("POI_CODE_06_HILL");
export const POI_CODE_07_HILL_DOWNWARDS = translatable(
	"POI_CODE_07_HILL_DOWNWARDS",
);
export const POI_CODE_08_HILL_UPWARDS = translatable(
	"POI_CODE_08_HILL_UPWARDS",
);
export const POI_CODE_10_INTERSECTION = translatable(
	"POI_CODE_10_INTERSECTION",
);
export const POI_CODE_11_LANE_MERGE = translatable("POI_CODE_11_LANE_MERGE");
export const POI_CODE_13_NARROW_ROAD = translatable("POI_CODE_13_NARROW_ROAD");
export const POI_CODE_16_PEDESTRIAN_CROSSING = translatable(
	"POI_CODE_16_PEDESTRIAN_CROSSING",
);
export const POI_CODE_19_RAILWAY_CROSSING = translatable(
	"POI_CODE_19_RAILWAY_CROSSING",
);
export const POI_CODE_21_SCHOOL_ZONE = translatable("POI_CODE_21_SCHOOL_ZONE");
export const POI_CODE_23_STOP_SIGN = translatable("POI_CODE_23_STOP_SIGN");
export const POI_CODE_24_TRAFFIC_LIGHT = translatable(
	"POI_CODE_24_TRAFFIC_LIGHT",
);
export const POI_CODE_25_TRAMWAY_CROSSING = translatable(
	"POI_CODE_25_TRAMWAY_CROSSING",
);
export const POI_CODE_27_WINDING_ROAD = translatable(
	"POI_CODE_27_WINDING_ROAD",
);
export const POI_CODE_28_YIELD = translatable("POI_CODE_28_YIELD");
export const POI_HARSH_BRAKING = translatable("POI_HARSH_BRAKING");
export const POI_HARSH_ACCELERATION = translatable("POI_HARSH_ACCELERATION");
export const REPORTS_DATE_RANGE_CALENDAR_TODAY = translatable(
	"reports_date_range_calendar_today",
);
export const REPORTS_DATE_RANGE_CALENDAR_YESTERDAY = translatable(
	"reports_date_range_calendar_yesterday",
);
export const REPORTS_DATE_RANGE_CALENDAR_THIS_WEEK = translatable(
	"reports_date_range_calendar_this_week",
);
export const REPORTS_DATE_RANGE_CALENDAR_LAST_WEEK = translatable(
	"reports_date_range_calendar_last_week",
);
export const REPORTS_DATE_RANGE_CALENDAR_THIS_MONTH = translatable(
	"reports_date_range_calendar_this_month",
);
export const REPORTS_DATE_RANGE_CALENDAR_LAST_MONTH = translatable(
	"reports_date_range_calendar_last_month",
);
export const REPORTS_DATE_RANGE_CALENDAR_DAYS_UP_TO_TODAY = translatable(
	"reports_date_range_calendar_days_up_to_today",
);
export const REPORTS_DATE_RANGE_CALENDAR_DAYS_STARTING_TODAY = translatable(
	"reports_date_range_calendar_days_starting_today",
);
export const REPORTS_RANKINGS_LOAD_BUTTON = translatable(
	"reports_rankings_load_button",
);
export const REPORTS_RANKINGS_RELOAD_BUTTON = translatable(
	"reports_rankings_reload_button",
);
export const REPORTS_EXPORT = translatable("reports_export");
export const REPORTS_WEEK_STARTING = translatable("reports_week_starting");
export const REPORTS_ASSIGNED = translatable("reports_assigned");
export const REPORTS_VIEWED = translatable("reports_viewed");
export const MISC_CREATE = translatable("misc_create");
export const CONTROLS_CREATE_TITLE = translatable("controls_create_title");
export const FILES_CREATE_NEW_FOLDER = translatable("files_create_new_folder");
export const FILES_FOLDER_NAME = translatable("files_folder_name");
export const FILES_FOLDER_DELETE_WARNING_TITLE = translatable(
	"files_folder_delete_warning_title",
);
export const FILES_FOLDER_DELETE_WARNING_SUBTITLE = translatable(
	"files_folder_delete_warning_subtitle",
);
export const REPORTS_BRIGHTCOACH_USER_RANKINGS = translatable(
	"reports_brightcoach_user_rankings",
);
export const REPORTS_BRIGHTCOACH_GROUP_RANKINGS = translatable(
	"reports_brightcoach_group_rankings",
);
export const GROUP_COMPARE_TITLE = translatable("group_compare_title");
export const PILLAR_HW_SPEED_SCORE = translatable("pillar_hw_speed_score");
export const PILLAR_HW_SEATBELT_SCORE = translatable(
	"pillar_hw_seatbelt_score",
);
export const PILLAR_HW_ACCELERATION_SCORE = translatable(
	"pillar_hw_acceleration_score",
);
export const PILLAR_HW_BRAKING_SCORE = translatable("pillar_hw_braking_score");
export const PILLAR_HW_CORNERING_SCORE = translatable(
	"pillar_hw_cornering_score",
);
export const MISC_UPDATE = translatable("misc_update");
export const MISC_RENAME = translatable("misc_rename");
export const COMPARE_YOUR_SAVED_SELECTIONS = translatable(
	"compare_your_saved_selections",
);
export const COMPARE_SAVE_UPDATE_SELECTION = translatable(
	"compare_save_update_selection",
);
export const COMPARE_SAVE_NEW_SELECTION = translatable(
	"compare_save_new_selection",
);
export const COMPARE_SAVE_SELECTION = translatable("compare_save_selection");
export const COMPARE_SAVED_SELECTIONS = translatable(
	"compare_saved_selections",
);
export const COMPARE_MY_SELECTION = translatable("compare_my_selection");
export const REPORTS_ALL_DRIVERS = translatable("reports_all_drivers");
export const REPORTS_ALL_GROUPS = translatable("reports_all_groups");
export const NAVIGATION_COMPLIANCEREPORT = translatable(
	"navigation_compliancereport",
);
export const REPORTS_COMPLIANCE_REPORT = translatable(
	"reports_compliance_report",
);
export const REPORTS_GROUP_RANKINGS_BY = translatable(
	"reports_group_rankings_by",
);
export const REPORTS_DRIVER_RANKINGS_BY = translatable(
	"reports_driver_rankings_by",
);
export const REPORTS_MONTH = translatable("reports_month");
export const REPORTS_WEEK = translatable("reports_week");
export const FORMS_SUCCESS_TITLE = translatable("forms_success_title");
export const FORMS_SUCCESS_SUBTITLE = translatable("forms_success_subtitle");
export const FORMS_SUCCESS_CTA = translatable("forms_success_cta");
export const COMPLIANCE_SUCCESS_TITLE = translatable(
	"compliance_success_title",
);
export const COMPLIANCE_SUCCESS_SUBTITLE = translatable(
	"compliance_success_subtitle",
);
export const COMPLIANCE_SUCCESS_CTA = translatable("compliance_success_cta");
export const COMPLIANCE_LAST_UPDATED = translatable("compliance_last_updated");
export const COMPLIANCE_EXPIRES = translatable("compliance_expires");
export const COMPLIANCE_COMPLETE = translatable("compliance_complete");
export const COMPLIANCE_VALID = translatable("compliance_valid");
export const COMPLIANCE_PENDING = translatable("compliance_pending");
export const COMPLIANCE_DUE_BY = translatable("compliance_due_by");
export const COMPLIANCE_DUE = translatable("compliance_due");
export const COMPLIANCE_OVERDUE = translatable("compliance_overdue");
export const COMPLIANCE_EXPIRED = translatable("compliance_expired");
export const COMPLIANCE_HOMEPAGE_TITLE = translatable(
	"compliance_homepage_title",
);
export const FILES_DELETE_FOLDER_WARNING_SUBTITLE = translatable(
	"files_delete_folder_warning_subtitle",
);
export const REPORTS_DOCUMENT_EXPIRES = translatable(
	"reports_document_expires",
);
export const REPORTS_FILTER = translatable("reports_filter");
export const NAVIGATION_REWARDS = translatable("navigation_rewards");
export const REWARDS_MENU_RAFFLES = translatable("rewards_menu_raffles");
export const REWARDS_MENU_CHARITIES = translatable("rewards_menu_charities");
export const REWARDS_HEADER_NAME = translatable("rewards_header_name");
export const REWARDS_HEADER_PERIOD = translatable("rewards_header_period");
export const REWARDS_HEADER_DRIVERS = translatable("rewards_header_drivers");
export const REWARDS_HEADER_COINS = translatable("rewards_header_coins");
export const REWARDS_HEADER_CHARITY_NAME = translatable(
	"rewards_header_charity_name",
);
export const REWARDS_HEADER_DONATION = translatable("rewards_header_donation");
export const REWARDS_HEADER_CONTRIBUTING = translatable(
	"rewards_header_contributing",
);
export const REWARDS_HEADER_TARGET = translatable("rewards_header_target");
export const REWARDS_HEADER_WINNERS = translatable("rewards_header_winners");
export const REWARDS_HEADER_DATE_REACHED = translatable(
	"rewards_header_date_reached",
);
export const REWARDS_NUM_WINNERS = translatable("rewards_num_winners");
export const REWARDS_NUM_WINNERS_SINGULAR = translatable(
	"rewards_num_winners_singular",
);
export const REWARDS_TITLE_ACTIVE_RAFFLES = translatable(
	"rewards_title_active_raffles",
);
export const REWARDS_TITLE_ACTIVE_CHARITIES = translatable(
	"rewards_title_active_charities",
);
export const REWARDS_TITLE_COMPLETED_RAFFLES = translatable(
	"rewards_title_completed_raffles",
);
export const REWARDS_TITLE_COMPLETED_CHARITIES = translatable(
	"rewards_title_completed_charities",
);
export const REWARDS_RESULTS_BACK_TO_REWARDS = translatable(
	"rewards_results_back_to_rewards",
);
export const REWARDS_RESULTS_BACK_TO_INSIGHTS = translatable(
	"rewards_results_back_to_insights",
);
export const REWARDS_RESULTS_DRIVERS_ENTERED = translatable(
	"rewards_results_drivers_entered",
);
export const REWARDS_RESULTS_COINS_ENTERED = translatable(
	"rewards_results_coins_entered",
);
export const REWARDS_RESULTS_TABLE_HEADER_NAME = translatable(
	"rewards_results_table_header_name",
);
export const REWARDS_RESULTS_TABLE_HEADER_COINS = translatable(
	"rewards_results_table_header_coins",
);
export const MISC_EXTERNAL_DRIVER = translatable("misc_external_driver");
export const REWARDS_ADD_REWARD = translatable("rewards_add_reward");
export const REWARDS_RAFFLE_EXPLANATION = translatable(
	"rewards_raffle_explanation",
);
export const GEOTAB_LEGAL_APP_POLICIES_TITLE = translatable(
	"geotab_legal_app_policies_title",
);
export const REWARDS_MANAGE_COMPS_CTA = translatable(
	"rewards_manage_comps_cta",
);
export const REWARDS_BUILDER_HEADER = translatable("rewards_builder_header");
export const REWARDS_BUILDER_BACK = translatable("rewards_builder_back");
export const REWARDS_BUILDER_FORM_NAME = translatable(
	"rewards_builder_form_name",
);
export const REWARDS_BUILDER_FORM_PRIZEDETAIL = translatable(
	"rewards_builder_form_prizeDetail",
);
export const REWARDS_BUILDER_FORM_PRIZEDETAIL_DESCRIPTION = translatable(
	"rewards_builder_form_prizeDetail_description",
);
export const REWARDS_BUILDER_FORM_GROUPID = translatable(
	"rewards_builder_form_groupId",
);
export const REWARDS_BUILDER_FORM_TYPEID = translatable(
	"rewards_builder_form_typeId",
);
export const REWARDS_BUILDER_FORM_TYPEID_RAFFLE = translatable(
	"rewards_builder_form_typeId_raffle",
);
export const REWARDS_BUILDER_FORM_TYPEID_CHARITY = translatable(
	"rewards_builder_form_typeId_charity",
);
export const REWARDS_BUILDER_FORM_RAFFLETYPE = translatable(
	"rewards_builder_form_raffleType",
);
export const REWARDS_BUILDER_FORM_RAFFLETYPE_CUSTOM = translatable(
	"rewards_builder_form_raffleType_custom",
);
export const REWARDS_BUILDER_FORM_RAFFLETYPE_CUSTOM_INFO = translatable(
	"rewards_builder_form_raffleType_custom_info",
);
export const REWARDS_BUILDER_FORM_NOTIFICATIONEMAILS = translatable(
	"rewards_builder_form_notificationEmails",
);
export const REWARDS_BUILDER_FORM_NOTIFICATIONEMAILS_DESCRIPTION = translatable(
	"rewards_builder_form_notificationEmails_description",
);
export const REWARDS_BUILDER_FORM_HEROIMAGE = translatable(
	"rewards_builder_form_heroImage",
);
export const REWARDS_BUILDER_FORM_STARTTIMESTAMP = translatable(
	"rewards_builder_form_startTimestamp",
);
export const REWARDS_BUILDER_FORM_ENDTIMESTAMP = translatable(
	"rewards_builder_form_endTimestamp",
);
export const REWARDS_BUILDER_FORM_AUTORESTART = translatable(
	"rewards_builder_form_autoRestart",
);
export const REWARDS_BUILDER_FORM_AUTORESTART_DESCRIPTION = translatable(
	"rewards_builder_form_autoRestart_description",
);
export const REWARDS_BUILDER_FORM_AUTORESTART_NEVER = translatable(
	"rewards_builder_form_autoRestart_never",
);
export const REWARDS_BUILDER_FORM_AUTORESTART_INFINITE = translatable(
	"rewards_builder_form_autoRestart_infinite",
);
export const REWARDS_BUILDER_FORM_AUTORESTART_CUSTOM = translatable(
	"rewards_builder_form_autoRestart_custom",
);
export const REWARDS_BUILDER_FORM_MAXOCCURENCES = translatable(
	"rewards_builder_form_maxOccurences",
);
export const REWARDS_BUILDER_FORM_MAXOCCURENCES_DESCRIPTION = translatable(
	"rewards_builder_form_maxOccurences_description",
);
export const REWARDS_BUILDER_FORM_NUMBEROFWINNERS = translatable(
	"rewards_builder_form_numberOfWinners",
);
export const REWARDS_BUILDER_FORM_COPY = translatable(
	"rewards_builder_form_copy",
);
export const REWARDS_BUILDER_FORM_COPY_DESCRIPTION = translatable(
	"rewards_builder_form_copy_description",
);
export const REWARDS_BUILDER_DELETE_CONFIRM_HEADER_CHARITY = translatable(
	"rewards_builder_delete_confirm_header_charity",
);
export const REWARDS_BUILDER_DELETE_CONFIRM_HEADER_RAFFLE = translatable(
	"rewards_builder_delete_confirm_header_raffle",
);
export const REWARDS_BUILDER_DELETE_CONFIRM_HEADER_COPY = translatable(
	"rewards_builder_delete_confirm_header_copy",
);
export const REWARDS_BUILDER_SAVE_SUCCESS = translatable(
	"rewards_builder_save_success",
);
export const REWARDS_BUILDER_SAVE_ERROR = translatable(
	"rewards_builder_save_error",
);
export const REWRADS_BUILDER_DELETED = translatable("rewrads_builder_deleted");
export const REWARDS_COMPETITION_FUTURE = translatable(
	"rewards_competition_future",
);
export const REWARDS_COMPETITION_RAFFLE_MADE_BY_BRIGHTMILE = translatable(
	"rewards_competition_raffle_made_by_brightmile",
);
export const REWARDS_COMPETITION_SUPER_RAFFLE_MADE_BY_BRIGHTMILE = translatable(
	"rewards_competition_super_raffle_made_by_brightmile",
);
export const REWARDS_COMPETITION_CHARITY_MADE_BY_BRIGHTMILE = translatable(
	"rewards_competition_charity_made_by_brightmile",
);
export const REWARDS_COMPETITION_ENABLED = translatable(
	"rewards_competition_enabled",
);
export const REWARDS_COMPETITION_START_DATE = translatable(
	"rewards_competition_start_date",
);
export const REWARDS_COMPETITION_END_DATE = translatable(
	"rewards_competition_end_date",
);
export const REWARDS_COMPETITION_RAFFLE_VALUE = translatable(
	"rewards_competition_raffle_value",
);
export const REWARDS_COMPETITION_RAFFLE_TYPE = translatable(
	"rewards_competition_raffle_type",
);
export const REWARDS_COMPETITION_OCCURENCES = translatable(
	"rewards_competition_occurences",
);
export const REWARDS_COMPETITION_OCCURENCES_SINGULAR = translatable(
	"rewards_competition_occurences_singular",
);
export const REWARDS_COMPETITION_TAG_REOCCURING = translatable(
	"rewards_competition_tag_reoccuring",
);
export const REWARDS_COMPETITION_TAG_AUTO_SEND_EMAIL = translatable(
	"rewards_competition_tag_auto_send_email",
);
export const REWARDS_COMPETITION_TAG_AUTO_CREATE_INSIGHT = translatable(
	"rewards_competition_tag_auto_create_insight",
);
export const REWARDS_COMPETITION_TAG_AUTO_AWARD_PRIZES = translatable(
	"rewards_competition_tag_auto_award_prizes",
);
export const REWARDS_COMPETITION_TOGGLE_EXAMPLE = translatable(
	"rewards_competition_toggle_example",
);
export const REWARDS_COMPETITION_TOGGLE_NORMAL = translatable(
	"rewards_competition_toggle_normal",
);
export const IMAGE_SELECTOR_DEFAULTS = translatable("image_selector_defaults");
export const IMAGE_SELECTOR_UPLOADED = translatable("image_selector_uploaded");
export const IMAGE_SELECTOR_UPLOAD_PLACEHOLDER = translatable(
	"image_selector_upload_placeholder",
);
export const IMAGE_SELECTOR_UPLOAD_ERROR = translatable(
	"image_selector_upload_error",
);
export const IMAGE_SELECTOR_ACTION_REPLACE = translatable(
	"image_selector_action_replace",
);
export const IMAGE_SEELCTOR_ACTION_EDIT = translatable(
	"image_seelctor_action_edit",
);
export const IMAGE_SEELCTOR_ACTION_DELETE = translatable(
	"image_seelctor_action_delete",
);
export const IMAGE_SELECTOR_DELETE_HEADER = translatable(
	"image_selector_delete_header",
);
export const IMAGE_SELECTOR_DELETE_ACTION_CONFIRM = translatable(
	"image_selector_delete_action_confirm",
);
export const IMAGE_SELECTOR_DELETE_ACTION_CANCEL = translatable(
	"image_selector_delete_action_cancel",
);
export const IMAGE_SELECTOR_EDIT_HEADER = translatable(
	"image_selector_edit_header",
);
export const MISC_BACK = translatable("misc_back");
export const MISC_UNDO = translatable("misc_undo");
export const REWARDS_CUSTOM_COMPETITION_EMAIL_SUBTEXT = translatable(
	"rewards_custom_competition_email_subtext",
);
export const FIVE_KEYS_VARIANT_POPUP_TITLE = translatable(
	"five_keys_variant_popup_title",
);
export const FIVE_KEYS_VARIANT_POPUP_COPY = translatable(
	"five_keys_variant_popup_copy",
);
export const CUSTOM_NOTIFICATION_TITLE = translatable(
	"custom_notification_title",
);
export const CUSTOM_NOTIFICATION_BACK = translatable(
	"custom_notification_back",
);
export const CUSTOM_NOTIFICATION_DESCRIPTION = translatable(
	"custom_notification_description",
);
export const CUSTOM_NOTIFICATION_NOTIFICATION_TITLE = translatable(
	"custom_notification_notification_title",
);
export const CUSTOM_NOTIFICATION_NOTIFICATION_TITLE_FILLER = translatable(
	"custom_notification_notification_title_filler",
);
export const CUSTOM_NOTIFICATION_NOTIFICATION_COPY = translatable(
	"custom_notification_notification_copy",
);
export const CUSTOM_NOTIFICATION_NOTIFICATION_COPY_FILLER = translatable(
	"custom_notification_notification_copy_filler",
);
export const CUSTOM_NOTIFICATION_SEND_DATE = translatable(
	"custom_notification_send_date",
);
export const CUSTOM_NOTIFICATION_SEND_TIME = translatable(
	"custom_notification_send_time",
);
export const CUSTOM_NOTIFICATION_PUSH_NOTIFICATION_BUTTON = translatable(
	"custom_notification_push_notification_button",
);
export const CUSTOM_LEADERBOARD_TITLE = translatable(
	"custom_leaderboard_title",
);
export const CUSTOM_LEADERBOARD_NAME_TITLE = translatable(
	"custom_leaderboard_name_title",
);
export const CUSTOM_LEADERBOARD_NAME_PREDICTIVE_TEXT = translatable(
	"custom_leaderboard_name_predictive_text",
);
export const CUSTOM_LEADERBOARD_INTRODUCTION_TITLE = translatable(
	"custom_leaderboard_introduction_title",
);
export const CUSTOM_LEADERBOARD_INTRODUCTION_PREDICTIVE_TEXT = translatable(
	"custom_leaderboard_introduction_predictive_text",
);
export const CUSTOM_LEADERBOARD_INTRODUCTION_HELP_POPUP = translatable(
	"custom_leaderboard_Introduction_help_popup",
);
export const CUSTOM_LEADERBOARD_DESCRIPTION_PREDICTIVE_TEXT = translatable(
	"custom_leaderboard_description_predictive_text",
);
export const CUSTOM_LEADERBOARD_DESCRIPTION_HELP_POPUP = translatable(
	"custom_leaderboard_description_help_popup",
);
export const CUSTOM_LEADERBOARD_DETAILS = translatable(
	"custom_leaderboard_details",
);
export const CUSTOM_LEADERBOARD_TEAM_CHOICE = translatable(
	"custom_leaderboard_team_choice",
);
export const CUSTOM_LEADERBOARD_DRIVER_CHOICE = translatable(
	"custom_leaderboard_driver_choice",
);
export const CUSTOM_LEADERBOARD_CHOOSE_METRIC = translatable(
	"custom_leaderboard_choose_metric",
);
export const CUSTOM_LEADERBOARD_CHOOSE_TIME_PERIOD = translatable(
	"custom_leaderboard_choose_time_period",
);
export const CUSTOM_LEADERBOARD_MONTHLY = translatable(
	"custom_leaderboard_monthly",
);
export const CUSTOM_LEADERBOARD_WEEKLY = translatable(
	"custom_leaderboard_weekly",
);
export const CUSTOM_LEADERBOARD_BIWEEKLY = translatable(
	"custom_leaderboard_biweekly",
);
export const CUSTOM_LEADERBOARD_CUSTOM = translatable(
	"custom_leaderboard_custom",
);
export const CUSTOM_LEADERBOARD_CHOOSE_PARTICIPANTS = translatable(
	"custom_leaderboard_choose_participants",
);
export const CUSTOM_LEADERBOARD_CHOOSE_PARTICIPANTS_TEXT = translatable(
	"custom_leaderboard_choose_participants_text",
);
export const CUSTOM_LEADERBOARD_PRIZE_AMOUNT = translatable(
	"custom_leaderboard_prize_amount",
);
export const CUSTOM_LEADERBOARD_FIRST_PLACE = translatable(
	"custom_leaderboard_first_place",
);
export const CUSTOM_LEADERBOARD_SECOND_PLACE = translatable(
	"custom_leaderboard_second_place",
);
export const CUSTOM_LEADERBOARD_THIRD_PLACE = translatable(
	"custom_leaderboard_third_place",
);
export const CUSTOM_LEADERBOARD_PREVIEW_CTA = translatable(
	"custom_leaderboard_preview_cta",
);
export const CUSTOM_LEADERBOARD_SAVE_CTA = translatable(
	"custom_leaderboard_save_cta",
);
export const SUB_PILLAR_HARSH_ACCELERATION_DESCRIPTION = translatable(
	"sub_pillar_harsh_acceleration_description",
);
export const SUB_PILLAR_HARSH_BRAKING_DESCRIPTION = translatable(
	"sub_pillar_harsh_braking_description",
);
export const LOGIN_EMAIL_USERNAME = translatable("login_email_username");
export const PILLAR_HARSH_ACCELERATION_TOOLTIP_TITLE = translatable(
	"pillar_harsh_acceleration_tooltip_title",
);
export const PILLAR_HARSH_ACCELERATION_TOOLTIP_COPY = translatable(
	"pillar_harsh_acceleration_tooltip_copy",
);
export const PILLAR_HARSH_BRAKING_TOOLTIP_TITLE = translatable(
	"pillar_harsh_braking_tooltip_title",
);
export const PILLAR_HARSH_BRAKING_TOOLTIP_COPY = translatable(
	"pillar_harsh_braking_tooltip_copy",
);
export const FIVE_KEYS_SCORE_TOOLTIP_COPY = translatable(
	"five_keys_score_tooltip_copy",
);
export const FIVE_KEYS_SCORE_TOOLTIP_COPY_TRAINING = translatable(
	"five_keys_score_tooltip_copy_training",
);
